(function (global, factory) {
    typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory() :
        typeof define === 'function' && define.amd ? define(factory) :
            typeof global.vuei18nLocales === 'undefined' ? global.vuei18nLocales = factory() : Object.keys(factory()).forEach(function (key) {global.vuei18nLocales[key] = factory()[key]});
}(this, (function () { 'use strict';
    return {
    "en": {
        "pagination": {
            "previous": "&laquo; Previous",
            "next": "Next &raquo;"
        },
        "listing": {
            "description": "A two family townhouse like no other in Brooklyn. If you have been searching for a home that truly offers space, light and intelligent design, you have found it.\n    64 Jackson is a custom-built, brand new home that spares nothing in it's attention to detail and craftsmanship. This is not a home built by a developer to sell, it is crafted residence where every aspect of construction went above and beyond what was required. Designed by Asa Barak Studio, the home features gorgeous, imported, water-struck Petersen bricks.\n    This 25'-wide house is fully equipped for entertaining up to 150 guests, or relaxing solo in the reading nook next to the fireplace. The layout is flexible- the parlor floor is over 1,085 sqft of open loft space. The kitchen features a mobile island, a custom stainless steel seamless welded sink and custom oak cabinetry with monocoat finish. The room opens so you're able to shift your entertaining needs on demand. There is an open gas fireplace, adjacent to the rear sun-room, with floor-to-ceiling glass and custom metal work. It's a space that must be seen to be truly appreciated.",
            "about_agent": "Nicolas has over 15 years of commercial and residential real estate experience. He is perhaps the most influential and instrumental retail broker in developing Hell’s Kitchen into a vibrant restaurant and retail scene with a cosmopolitan appeal. As one of the founding partners for a prominent real estate firm, Wide Arms Realty, Nicolas has helped oversee relationships with several key owners and co-op boards.",
            "property_details": "You are located less than two blocks away from the L train and a short breeze to the J and Z train. Feel like relaxing in a public outdoor environment? Take a stroll through Irving Square Park and find time to relax, just a few blocks away from your soon to be home. Feel free to contact us to view this lovely townhouse."
        },
        "auth": {
            "login": {
                "welcome": "Welcome",
                "login_to_continue": "Login to continue",
                "your_email": "Email address",
                "your_email_placeholder": "johndoe@realestate.com",
                "your_password": "Password",
                "your_password_placeholder": "Enter password",
                "login": "Log in",
                "dont_have_an_account": "Don't have an account?",
                "sign_up_for_free": "Sign up for free",
                "forgot_password": "Forgot password?",
                "failed": "Please check login details",
                "log_into_pillar": "Log into Pillar",
                "or": "or",
                "continue_with_google": "Continue with Google",
                "continue_with_facebook": "Continue with Facebook",
                "continue_with_email": "Continue with email"
            },
            "change_password": {
                "enter_new_password": "Enter new password",
                "new_password": "New password",
                "password_placeholder": "Enter password",
                "confirm_new_password": "Confirm new password",
                "set_new_password": "Set new password",
                "take_me_back_to_login_screen": "Take me back to login screen"
            },
            "reset_password": {
                "reset_password": "Reset password",
                "reset_password_description": "We can help you reset your password using the email address linked to your account",
                "your_email": "Your email",
                "your_email_placeholder": "johndoe@realestate.com",
                "reset_my_password": "Reset my password",
                "take_me_back_to_login_screen": "Take me back to Login screen"
            }
        },
        "listing_form": {
            "listing_template": {
                "select_a_template": "Select a template",
                "choose_one": "Choose one of the templates from our list. Each one was made for a specific purpose. Don't worry - you can change template later if you want to.",
                "select": "Select",
                "select_template": "Launch Website",
                "preview": "Preview",
                "selected": "Selected",
                "baroque": "Baroque",
                "this_sophisticated": "This sophisticated template can be used for a variety of properties, and works best with more classical ones.",
                "modernist": "Modernist",
                "minimalist_template": "Minimalist template helps viewers focus on the content - works best with more modern properties or properties with high quality photos.",
                "gothic": "Gothic",
                "this_unique": "This unique template will help you stand out even more because of it’s dark design. Suitable for a range of properties.",
                "byzantine": "Byzantine",
                "cozy_and": "Cozy and friendly always wins the game. This light and playful design will make your property look even more comfy.",
                "art_deco": "Art Deco",
                "thanks_to": "Thanks to it’s blue accents this template is most suited for properties that need to convey trust. Perfect for corporate or minimalist properties.",
                "most_popular": "Most popular",
                "victorian": "Victorian",
                "our_most": "Our most universal template that works for any type of property. Make your listing look more elegant with hunter green color accents."
            },
            "listing_photos": {
                "review_and_add_more_photos": "Review and add more photos",
                "upload_photos_description": "Upload photos of the property you want to publish. Reorder your photos whichever way you like by dragging them with your mouse",
                "upload_photos": "Upload photos",
                "upload_more_photos": "Upload more photos"
            },
            "help_popup": {
                "information_about_the_location": "Information about the location",
                "information_about_the_location_description": "Here you can add information related to the area where the property is - this paragraph will be shown next to the map in “Location” section",
                "top_section_title": "Top section title",
                "top_section_description": "It’s the first piece of information visitors see when they open up your website. We recommend a short and catchy phrase.",
                "top_section_square_footage": "Top section - Square footage & Price",
                "top_section_square_footage_description": "Please enter the amount square footage and price for your listing.",
                "top_section_beds_and_baths": "Top section - Beds & Baths",
                "top_section_beds_and_baths_description": "Please enter the amount of bedrooms and bathrooms your listing has.",
                "top_section_hero_image": "Top section photo (or add video)",
                "top_section_hero_image_description": "Pridėkite objekto nuotrauką arba video, kuris bus rodomas puslapio viršuje. Turite objekto video? Užvedę pele ant nuotraukos paspauskite \"Pridėti video\" tam, kad pridėtumėte YouTube ar Vimeo video.",
                "top_section_logo": "Top section - Logo",
                "top_section_logo_description": "Upload your personal or company logo for a custom branded feel. ",
                "overview_title_and_text": "Overview - overview title and text",
                "overview_title_and_text_description": "Here you can add a longer description of the property you’re selling. Add a custom title to make this listing even more unique",
                "overview_images": "Overview - overview images",
                "overview_images_description": "You have an option to upload two photos of the property that stand out from the rest to make the property more attractive.",
                "amenities": "Amenities",
                "amenities_description": "Add property features to catch visitors’ attention. Simply type in a word and press enter. To remove a feature, click on the “X” icon next to selected feature",
                "listing_photos": "Listing photos",
                "listing_photos_description": "This is where you show all the photos of the property. You can also group photos into sections to clearer visibility.",
                "floor_plans": "Floor plans",
                "floor_plans_description": "Floor plans, especially 3D ones, can help viewers better understand the property and it’s layout, increasing the amount of viewing. If only have a simple floor plan and want to transformit into a custom 3D plan, contact us and we’ll be happy to help.",
                "share_a_bit_about_yourself": "Share a bit about yourself",
                "share_a_bit_about_yourself_description": "Let your website visitors know more about you - share a couple of sentences about yourself and your expertise.",
                "add_your_social_media_links": "Add your social media links",
                "add_your_social_media_links_description": "Let website visitors find you on social media by simply copy pasting links to your social media profiles. You can get them by opening each of your social profiles and copying the links from your browser",
                "video_tour": "Upload video or virtual tour",
                "video_tour_description": "Upload property video and / or virtual tour and we will show them between Amenities and Photo gallery sections",
                "listing_agent_title": "Add a listing agent",
                "listing_agent_description": "If you're not the person who originally listed this property and you want that agent to be mentioned in the website, we recommend adding their contact info through here.",
                "co_agent_title": "Add a co-agent",
                "co_agent_description": "Have you listed this property together with another agent? Add agent’s information below and the agent will be displayed with you in the Agent section.",
                "schedule_showing": "Let visitors book a showing",
                "schedule_showing_description": "Convert more visitors by letting them schedule an in person tour or a virtual showing directly through the website. Simply set your available hours when visitors can schedule showings and we will let you know via email.",
                "messenger": "Messenger live chat",
                "messenger_description": "Convert website visitors into hot leads with a Facebook Messenger live chat tool built directly into your listing website. You need to be a Facebook Business Page admin to connect and chat with visitors directly through Messenger app, without the need to download any additional apps.",
                "additional_documents": "Add additional documents",
                "additional_documents_description": "Attach documents (like disclosures or seller information) to your listing so visitors see all the details about the property in one place. You can also add links to external websites pointing to more information. <br> Accepted file types: PDF, DOC, XLS, CSV, ODT, TXT.",
                "as_top_section_cover_title": "Add video as top section cover",
                "as_top_section_cover_description": "You can also Include this video at the top of the website instead of a photo  - it will be the first thing visitors see.",
                "exit_intent_popup": "Exit intent pop-up",
                "exit_intent_popup_description": "Capture more leads with a pop-up built for visitors leaving your website. The pop-up asks visitors to leave their contact information to get exclusive offers in their area. This way you can contact them and offer other properties they might be interested in.",
                "lock_listing": "View listing only after sign up",
                "lock_listing_description": "If you have a new or upcoming property for sale and want to generate leads, let visitors unlock this listing by signing up with email. Please note: the listing would not be accessible without sign up.",
                "listing_status": "Listing status",
                "listing_status_description": "Change listing status to Just listed, Active, Price reduced, Pending or Sold to let visitors know what’s the current state of this property. By updating your listing status you can message your contacts and update social media to gain more attention and generate leads",
                "display_more_listings": "Display more listings",
                "display_more_listings_description": "Let your website visitors discover other listings you have on Pillar by showcasing them at the bottom of the website. Other listings you have on Pillar will be shown in the “More listings” section.",
                "change_colors": "Change template colors",
                "change_colors_description": "Change the colors of the selected template to make your property website even more unique. Choose from recommended colors, which are compatible with both light and dark modes. You can also use a custom color by entering it’s HEX codes. We do not recommend using the “Custom” option, because it can make the property website look low-quality."
            },
            "agent_details": {
                "add_agent_details": "Add agent details",
                "fill_in": "Fill in your contact details so visitors know who’s the person presenting the listing",
                "agent_profile_photo": "Agent profile photo",
                "upload_an_image": "Upload an image",
                "full_name": "Full name",
                "full_name_placeholder": "John Doe",
                "occupation": "Occupation",
                "occupation_placeholder": "Real estate agent, Broker, Realtor...",
                "contact_email": "Contact email",
                "contact_email_placeholder": "johndoe@company.com",
                "company": "Company",
                "company_placeholder": "Agency",
                "website": "Website",
                "website_placeholder": "agency.com",
                "mobile_phone_number": "Mobile phone number",
                "mobile_phone_number_placeholder": "888 888 888",
                "share_a": "Share a bit about yourself",
                "share_a_placeholder": "e.g. Nicolas has over 15 years of commercial and residential real estate experience. He is perhaps the most influential and instrumental retail broker in developing Hell’s Kitchen into a vibrant restaurant and retail scene with a cosmopolitan appeal. As one of the founding partners for a prominent real estate firm, Wide Arms Realty, Nicolas has helped oversee relationships with several key owners and co-op boards.",
                "social_media_links": "Social media links",
                "copy_paste": "Copy paste your social media links for others to see them",
                "make_website_unbranded": "Make website unbranded",
                "co_agent": "Add a co-agent",
                "co_agent_profile_photo": "Co-agent’s profile photo",
                "co_agents_company": "Co-agent’s company",
                "co_agents_website": "Co-agent company’s website",
                "listing_agent": "Add a listing agent",
                "listing_agent_profile_photo": "Listing agent photo",
                "listing_agent_full_name": "Listing agent’s full name",
                "listing_agent_occupation": "Listing agent’s occupation",
                "listing_agent_contact_email": "Listing agent’s contact email",
                "listing_agent_company": "Listing agent’s company",
                "listing_agent_website": "Listing agent’s company website",
                "listing_agent_mobile_phone_number": "Listing agent’s mobile phone no."
            },
            "crop": {
                "crop_and_resize_photo": "Crop & resize photo",
                "adjust_your": "Adjust your photo so it looks better on your selected template",
                "crop": "Crop"
            },
            "listing_details": {
                "edit_listing_address": "Edit listing address",
                "we_will": "We will use this information to locate the property on the map and show it to the visitors",
                "find_your": "Find your property address",
                "type_address": "Type address here",
                "country": "Country",
                "street": "Street",
                "city": "City",
                "state": "State",
                "region_county": "Region / County",
                "zip_code": "Zip code",
                "postal_code": "Postal Code",
                "information_about": "Information about the area",
                "continue": "Continue",
                "information_about_placeholder": "e.g. You are located less than two blocks away from the L train and a short breeze to the J and Z train. Feel like relaxing in a public outdoor environment? Take a stroll through Irving Square Park and find time to relax, just a few blocks away from your soon to be home. Feel free to contact us to view this lovely townhouse.",
                "select_country": "Select country"
            },
            "progress_bar": {
                "template": "Template",
                "address": "Address",
                "agent": "Agent",
                "photos": "Photos",
                "remaining_info": "Remaining info",
                "domain": "Domain"
            },
            "remaining_details": {
                "add_remaining_information": "Add remaining information",
                "finish_adding": "Finish adding remaining information to your new website - you’re almost there!",
                "selected_subdomain": "Selected subdomain",
                "selected_domain": "Selected domain",
                "change": "Change",
                "top_section": "Top section",
                "title": "Property title",
                "title_placeholder": "A location unlike any other",
                "bedrooms": "Bedrooms",
                "bathrooms": "Bathrooms",
                "square_footage": "Square footage",
                "square_meters": "Size M²",
                "price": "Price",
                "currency": "Currency",
                "top_section_cover": "Top section photo (or add video)",
                "company_logo": "Company logo",
                "upload_logo": "Upload logo",
                "select_from_uploads": "Select from uploads",
                "transparent_background_recommended": "(transparent background recommended)",
                "change_photo": "Change photo",
                "crop_and_resize": "Crop and resize",
                "description": "Description",
                "description_title": "Description title (optional)",
                "description_title_placeholder": "Icon living",
                "describe_your_property": "Describe your property here",
                "describe_your_property_placeholder": "A two family townhouse like no other in Brooklyn. If you have been searching for a home that truly offers space, light and intelligent design, you have found it. \n64 Jackson is a custom-built, brand new home that spares nothing in it's attention to detail and craftsmanship. This is not a home built by a developer to sell, it is crafted residence where every aspect of construction went above and beyond what was required. Designed by Asa Barak Studio, the home features gorgeous, imported, water-struck Petersen bricks.",
                "description_images": "Description images",
                "select_1st_favorite": "Select 1st favorite photo",
                "select_2nd_favorite": "Select 2nd favorite photo",
                "floor_plans": "Floor plans",
                "floor_plan_images": "Floor plan images",
                "upload_floor_plans": "Upload floor plans",
                "amenities": "Amenities",
                "amenities_description": "Add property details on your own or pick them from the list",
                "add_custom_amenities": "Add custom amenities",
                "add": "Add",
                "rooms": "Rooms",
                "floor_covering": "Floor covering",
                "indoor_features": "Indoor features",
                "building_and_exterior": "Building & Exterior",
                "architectural_style": "Architectural style",
                "exterior": "Exterior",
                "roof": "Roof",
                "view": "View",
                "outdoors_and_parking": "Outdoors & Parking",
                "parking": "Parking",
                "features": "Features",
                "outdoor_amenities": "Outdoor amenities",
                "expand": "Expand",
                "utilities": "Utilities",
                "cooling": "Cooling",
                "heating": "Heating",
                "publish": "Publish",
                "preview_website": "Preview website",
                "breakfast_nook": "Breakfast nook",
                "dining_room": "Dinning room",
                "family_room": "Family room",
                "laundry_room": "Laundry room",
                "library": "Library",
                "master_bath": "Master bath",
                "mud_room": "Mud room",
                "office": "Office",
                "pantry": "Pantry",
                "recreation_room": "Recreation room",
                "workshop": "Workshop",
                "solarium_atrium": "Solarium / Atrium",
                "sun_room": "Sun room",
                "walk_in_closet": "Walk-in closet",
                "carpet_floor": "Carpet floor",
                "concrete_floor": "Concrete floor",
                "hardwood_floor": "Hardwood floor",
                "laminate_floor": "Laminate floor",
                "linoleum_vinyl_floor": "Linoleum / Vinyl floor",
                "slate_floor": "Slate floor",
                "softwood_floor": "Softwood floor",
                "tile_floor": "Tile floor",
                "attic": "Attic",
                "cable_ready": "Cable ready",
                "ceiling_fans": "Ceiling fans",
                "double_pane_windows": "Double pane windows",
                "fireplace": "Fireplace",
                "intercom": "Intercom",
                "jetted_tub": "Jetted tub",
                "security_system": "Security system",
                "skylights": "Skylights",
                "wired": "Wired",
                "bungalow": "Bungalow",
                "cape_cod_style": "Cape cod style",
                "modern_style": "Modern style",
                "victorian_style": "Victorian style",
                "colonial_style": "Colonial style",
                "ranch_rambler": "Ranch / Rambler",
                "contemporary_style": "Contemporary style",
                "spanish_style": "Spanish style",
                "french_style": "French style",
                "georgian_style": "Georgian style",
                "loft": "Loft",
                "tudor": "Tudor",
                "brick_exterior": "Brick exterior",
                "cement_concrete_exterior": "Cement / Cocrete exterior",
                "composition_exterior": "Composition exterior",
                "metal_exterior": "Metal exterior",
                "stone_exterior": "Stone exterior",
                "wood_wood_product_exterior": "Wood / wood product exterior",
                "vinyl_exterior": "Vinyl exterior",
                "stucco_exterior": "Stucco exterior",
                "asphalt_roof": "Asphalt roof",
                "built_up_roof": "Built-up roof",
                "composition_roof": "Composition roof",
                "metal_roof": "Metal roof",
                "shake_shingle_roof": "Shake / Shingle roof",
                "slate_roof": "Slate roof",
                "tile_roof": "Tile roof",
                "city_view": "City view",
                "mountain_view": "Mountain view",
                "park_view": "Park view",
                "territorial_view": "Territorial view",
                "water_view": "Water view",
                "no_parking": "No parking",
                "off_street_parking": "Off-street parking",
                "on_street_parking": "On-street parking",
                "garage_detached": "Garage - detached",
                "garage_attached": "Garage - attached",
                "carport_parking": "Carport parking",
                "gated_entry": "Gated entry",
                "basketball_court": "Basketball court",
                "near_transportation": "Near transportation",
                "controlled_access": "Controlled access",
                "sports_court": "Sports court",
                "childrens_playground": "Children's playground",
                "tennis_court": "Tennis court",
                "elevator": "Elevator",
                "doorman": "Doorman",
                "balcony_patio": "Balcony / patio",
                "hot_tub_spa": "Hot tub / spa",
                "greenhouse": "Greenhouse",
                "garden": "Garden",
                "fenced_yard": "Fenced yard",
                "dock": "Dock",
                "deck": "Deck",
                "barbecue_area": "Barbecue area",
                "lawn": "Lawn",
                "pond": "Pond",
                "pool": "Pool",
                "porch": "Porch",
                "sauna": "Sauna",
                "central_cooling": "Central cooling",
                "solar_cooling": "Solar cooling",
                "evaporative_cooling": "Evaporative cooling",
                "geothermal_cooling": "Geothermal cooling",
                "refrigeration": "Refrigeration",
                "ac": "A/C",
                "coal_heating": "Coal heating",
                "electric_heating": "Electric heating",
                "gas_heating": "Gas heating",
                "oil_heating": "Oil heating",
                "propane_butane_heating": "Propane / butane heating",
                "wood_pellet_heating": "Wood / pellet heating",
                "solar_heating": "Solar heating",
                "change_top_section_image": "Select top section image",
                "change_top_section_image_description": "Select one image to be shown at the top of your site - this will be the first thing your site visitors will see when they enter your website. Want to add a new photo? Go to “Photos” tab and upload there.",
                "change_description_image": "Select description photo",
                "change_description_image_description": "Select one of the photos to be shown together with the website description",
                "back_to_editing": "Back to editing",
                "you_are_almost_done": "You are almost done!",
                "you_are_almost_done_text": "Pick a domain and share your website with the world",
                "select_domain": "Select domain",
                "interior": "Interior",
                "property_title_is_missing": "Property title is missing",
                "description_text_is_missing": "Description text is missing",
                "messenger": "Messenger live chat",
                "connect_facebook_page": "Connect your Facebook page to chat with your listing website visitors in real time. Please note that live chat will not be available until your listing is Published.",
                "select_facebook_page": "Select a page to connect",
                "connect_with_facebook": "Connect with Facebook",
                "select_a_page": "Select a page",
                "exit_intent_popup": "Show exit intent pop-up",
                "just_listed": "Just listed",
                "price_reduced": "Price reduced",
                "pending": "Pending",
                "sold": "Sold",
                "active": "Active",
                "no_status": "Hide status",
                "capture_more_leads": "Capture more leads with a pop-up shown to website visitors that are going to leave the site",
                "visitors_have_to_signup": "Visitors have to sign up with email to see this listing. Great for new or upcoming properties",
                "view_after_signup": "View listing only after sign up",
                "listing_status": "Listing status",
                "display_more_listings": "Display more listings",
                "display_more_listings_description": "Let your website visitors discover other listings you have on Pillar with an additional “More listings” section.",
                "change_colors": "Change colors",
                "change_colors_description": "Customise your property website with different colors",
                "choose_color": "Choose one of the recommended colors below, which are compatible with both light and dark modes. You can also use a custom color by entering its HEX code.",
                "button_color": "Button color",
                "accent_color": "Accent color",
                "custom": "Custom"
            },
            "select_domain": {
                "select_domain": "Select free or paid domain",
                "choose_from": "Choose from top and real estate unique domains. From $15",
                "use_our_subdomain": "A) Use our free subdomain",
                "always_free": "Always free, change whenever you wish",
                "or_buy": "B) Buy unique domain",
                "search": "Search",
                "get_the_perfect_domain": "Get the perfect domain",
                "view_other_domains": "View other domains",
                "show_country_domains": "Show country domains",
                "unavailable": "Unavailable",
                "checkout": "Checkout",
                "payment_details": "Payment details",
                "your_payment_was_successful": "Your payment was successful",
                "congratulations": "Congratulations! Your listing will be accessible on",
                "grab_a_coffee": "Grab a coffee and relax - we’re moving everything to your new domain and it will be ready in about an hour.",
                "in_the_meantime": "In the meantime you can choose to edit the listing or publish it straight away.",
                "publish_website": "Publish website",
                "back_to_editing": "Back to editing",
                "simply_enter_the_name": "Simply enter the name of your subdomain and click select",
                "your_domain": "Your domain",
                "you_are_owner_of": "You are an owner of",
                "domain": "domain",
                "for_this_listing": "for this listing",
                "the_domain_you_bought_is": "The domain you bought is",
                "please_contact_our_support": "Please contact our support team if you would like to change your domain.",
                "view_live_website": "View live website",
                "go_to_dashboard": "Go to dashboard",
                "selected": "Selected",
                "select_free_subdomain": "Select free subdomain",
                "selected_free_subdomain": "Selected"
            }
        },
        "dashboard": {
            "your_listings": "Your listings",
            "upgrade": "Upgrade",
            "upgrade_to_create_another_listing": "Upgrade to create another listing",
            "upgrade_plan": "Upgrade plan",
            "account_settings": "Account settings",
            "contact_support": "Contact support",
            "facebook_pixel": "Facebook Pixel",
            "logout": "Logout",
            "edit": "Edit",
            "draft": "Draft",
            "published": "Published",
            "create_new_listing": "Create new listing",
            "unpublish": "Unpublish",
            "unpublish_text": "Are you sure want to mark this website as unpublished? It will no longer be visible to your website visitors",
            "unpublish_website": "Unpublish website",
            "delete": "Delete",
            "delete_text": "Are you sure you want to delete this website?",
            "delete_website": "Delete website",
            "duplicate": "Duplicate",
            "duplicate_listing": "Duplicate listing",
            "duplicate_text": "Are you sure you want to duplicate this listing?",
            "listing_duplicated": "Listing has been duplicated",
            "unable_to_duplicate": "Unable to duplicate. Please upgrade to create more listings",
            "no_status": "No status",
            "just_listed": "Just listed",
            "active": "Active",
            "price_reduced": "Price reduced",
            "pending": "Pending",
            "sold": "Sold",
            "view_analytics": "View analytics",
            "search_address": "Search for an address",
            "filter": "Filter",
            "created": "Created",
            "visit": "Visit"
        },
        "passwords": {
            "password": "Passwords must be at least eight characters and match the confirmation.",
            "reset": "Your password has been reset!",
            "sent": "We have e-mailed your password reset link!",
            "token": "This password reset token is invalid.",
            "user": "We can't find a user with that e-mail address."
        },
        "templates": {
            "sections": {
                "additional_files": {
                    "download_file": "Download FILE",
                    "link": "Link",
                    "open_link": "Open LINK"
                }
            },
            "1": {
                "amenities": {
                    "1": "High ceilings",
                    "2": "City lights views",
                    "3": "Great schools close",
                    "4": "Central heating",
                    "5": "Large kitchen",
                    "6": "Large lot",
                    "7": "New construction",
                    "8": "Walk-in closets",
                    "9": "Open floor plan",
                    "10": "Quiet and private",
                    "11": "City center",
                    "12": "Sauna",
                    "13": "Huge rooftop deck",
                    "14": "Backyard",
                    "15": "Close to shopping"
                },
                "country": "United States",
                "title": "A location unlike any other",
                "overview_title": "Icon living",
                "overview_description": "A two family townhouse like no other in Brooklyn. If you have been searching for a home that truly offers space, light and intelligent design, you have found it.\n  64 Jackson is a custom-built, brand new home that spares nothing in it's attention to detail and craftsmanship. This is not a home built by a developer to sell, it is crafted residence where every aspect of construction went above and beyond what was required. Designed by Asa Barak Studio, the home features gorgeous, imported, water-struck Petersen bricks.\n  This 25'-wide house is fully equipped for entertaining up to 150 guests, or relaxing solo in the reading nook next to the fireplace. The layout is flexible- the parlor floor is over 1,085 sqft of open loft space. The kitchen features a mobile island, a custom stainless steel seamless welded sink and custom oak cabinetry with monocoat finish. The room opens so you're able to shift your entertaining needs on demand. There is an open gas fireplace, adjacent to the rear sun-room, with floor-to-ceiling glass and custom metal work. It's a space that must be seen to be truly appreciated.",
                "currency_symbol": "$",
                "full_name": "Nicolas Aaron",
                "occupation": "Licensed Real Estate Salesperson",
                "company": "Wide Arms Realty",
                "contact_email": "nicolas.aaron@widearmsrealty.com",
                "mobile_phone_number": "646.400.3609",
                "website": "https://usepillar.com",
                "about": "Nicolas has over 15 years of commercial and residential real estate experience. He is perhaps the most influential and instrumental retail broker in developing Hell’s Kitchen into a vibrant restaurant and retail scene with a cosmopolitan appeal. As one of the founding partners for a prominent real estate firm, Wide Arms Realty, Nicolas has helped oversee relationships with several key owners and co-op boards.",
                "facebook": "https://usepillar.com",
                "twitter": "https://usepillar.com",
                "linkedin": "https://usepillar.com",
                "instagram": "https://usepillar.com",
                "city": "NY",
                "state": "",
                "street": "67 Jackson St",
                "postcode": "postcode",
                "property_details": "You are located less than two blocks away from the L train and a short breeze to the J and Z train. Feel like relaxing in a public outdoor environment? Take a stroll through Irving Square Park and find time to relax, just a few blocks away from your soon to be home. Feel free to contact us to view this lovely townhouse.",
                "plans": "Floor plans"
            },
            "general": {
                "overview": "Overview",
                "amenities": "Amenities",
                "amenities_you_will_enjoy": "Amenities You will enjoy",
                "photos": "Photos",
                "view_all_photos": "[2,9] View all {count} photos|[10,20] View all {count} photos|[21,29] View all {count} photos",
                "floor_plans": "Floor plans",
                "map": "Map",
                "contact": "Contact",
                "agent": "Agent",
                "inquire": "Inquire",
                "beds": "Bed|Beds",
                "baths": "Bath|Baths",
                "bedrooms": "Bedroom|Bedrooms",
                "bathrooms": "Bathroom|Bathrooms",
                "Sq. Ft.": "Sq. Ft.",
                "tour_this_house": "Tour this property",
                "tour_the_house": "Tour the property",
                "view_all": "View all",
                "view_photos": "photos",
                "location": "Location",
                "open_maps": "Open maps",
                "presented_by": "Presented by",
                "get_in_touch": "Get in touch",
                "first_name": "First name",
                "last_name": "Last name",
                "email_address": "Email address",
                "email": "Email",
                "phone": "Phone",
                "phone_number": "Phone number",
                "your_message": "Your message",
                "message": "Message",
                "send_message": "Send message",
                "send_inquiry": "Send Inquiry",
                "send": "Send",
                "powered_by": "Powered by",
                "share_this_property": "Share this property",
                "close": "Close",
                "view_our_gallery": "View our Gallery",
                "location_in_town": "Location in town",
                "any_questions": "Any questions?",
                "reach_out_to_us": "Reach out to us",
                "type_here": "Type here ...",
                "view_photo": "View photo",
                "address": "Address",
                "price_from": "Price from",
                "area": "Area",
                "explore": "Explore",
                "thank_you_for_your_interest": "Thank you for your interest in",
                "we_will_contact_you": "A member of our team will be in touch soon to schedule a discreet and confidential conversation.",
                "scroll": "Scroll",
                "gallery": "Gallery",
                "location_overflow": "Location",
                "presented_by_overflow": "Presented by",
                "video_tour": "Video",
                "video": "Video",
                "virtual_tour": "Virtual tour",
                "more": "More",
                "listed_by": "Listed by",
                "or": "Or",
                "showing": "Showing",
                "book_a_showing": "Book a Showing",
                "just_listed": "JUST LISTED",
                "price_reduced": "PRICE REDUCED",
                "pending": "PENDING",
                "sold": "SOLD",
                "active": "ACTIVE",
                "more_information": "More information",
                "take_a_tour": "Take a tour",
                "more_listings": "More listings"
            }
        },
        "free_trial": {
            "your_free_trial_ends_in": "Your free trial ends in",
            "days": "{count} day|{count} days",
            "upgrade": "Upgrade"
        },
        "subdomain_selected": {
            "subdomain_selected": "Subdomain selected",
            "congratulations": "Congratulations! Your listing will be accessible on",
            "congratulations_description": "You can choose to edit the listing or publish it straight away",
            "publish_website": "Publish website",
            "back_to_editing": "Back to editing"
        },
        "common": {
            "back": "Back",
            "continue": "Continue",
            "next": "Next",
            "max_file_size": "Max file size: 20Mb",
            "preview": "Preview",
            "file_size_too_big": "File size is too big - max file size is 20Mb.",
            "close": "Close",
            "cancel": "Cancel",
            "select": "Select",
            "crop_and_resize": "Crop & resize",
            "change_photo": "Change photo",
            "remove_photo": "Remove photo",
            "are_you_sure": "Are you sure you want to remove this photo?",
            "remove": "Remove",
            "terms_of_service": "Terms of service",
            "terms_of_service_nominative": "Terms of service",
            "privacy_policy": "Privacy policy",
            "and": "and",
            "all_rights_reserved": "© Pillar Technologies LTD 2020. All rights reserved.",
            "currency_sign": "$",
            "dashboard": "Dashboard",
            "desktop": "Desktop",
            "tablet": "Tablet",
            "mobile": "Mobile",
            "view_demo": "View demo",
            "select_template": "Launch Website",
            "add_video": "Add video",
            "replace_video": "Replace video",
            "select_photo": "Select photo",
            "save": "Save",
            "blog": "Blog",
            "listing_unavailable": "The listing is currently not available",
            "limit_reached_upgrade_plan": "Active listing limit reached - please upgrade your plan"
        },
        "card_details": {
            "card_number": "Card number",
            "name_on_card": "Name on card",
            "name_on_card_placeholder": "John Doe",
            "expiration": "Expiration",
            "order_summary": "Order summary",
            "domain_for_listing_site": "Domain for listing site",
            "one_time_payment": "One-time payment",
            "no_hidden_fees": "No hidden fees, no subscription",
            "valid_for_one_year": "Valid for one year",
            "pay": "Pay",
            "card_number_required": "Card number required",
            "month_required": "Month is required",
            "cvc_required": "CVC is required",
            "name_is_required": "Name is required"
        },
        "account": {
            "account_settings": "Account settings",
            "profile": "Profile",
            "password": "Password",
            "billing": "Billing",
            "first_name": "First name",
            "first_name_placeholder": "Enter first name",
            "last_name": "Last name",
            "last_name_placeholder": "Enter last name",
            "work_email_address": "Work email address",
            "work_email_address_placeholder": "Enter email address",
            "old_password": "Old password",
            "new_password": "New password",
            "password_placeholder": "Enter password",
            "confirm_new_password": "Confirm new password",
            "change_password": "Change password",
            "update_settings": "Update settings",
            "active_listings": "{0} There are no active listings|[1] {count} active listing|[2,*] {count} active listings",
            "your_plan": "Your plan",
            "upgrade": "Upgrade",
            "cancel_plan": "Cancel plan",
            "change_card": "Change card",
            "payment_method": "Payment method",
            "update_card": "Update card",
            "cancelled": "Cancelled",
            "active_until": "active until",
            "renew": "Renew",
            "we_will_send_you_text_notifications": "We will send you text notifications when you receive a new lead on one of your property websites",
            "phone_number": "Phone number for SMS notifications"
        },
        "analytics": {
            "yesterday": "Yesterday",
            "last_week": "Last week",
            "last_month": "Last month",
            "last_7_days": "Last 7 days",
            "last_30_days": "Last 30 days",
            "all_time": "All time"
        },
        "plan_ended": {
            "please_reactivate_your_plan": "Please reactivate your plan",
            "free_trial_has_ended": "Free trial has ended",
            "your": "Your",
            "subscription_has_ended": "subscription has ended",
            "days_free_trial_has_ended": "day free trial has ended",
            "description": "We hope you enjoyed using Pillar. Please upgrade in order to continue using our service.",
            "description2": "Something wasn't right? We would love to hear from you if you had any questions, feature requests or feedback!",
            "see_plans": "See plans",
            "contact_support": "Contact support"
        },
        "early_preview": {
            "finish_setting_up_title": "Finish setting up your website in minutes",
            "finish_setting_up_description": "Edit the rest of the details and pick domain for your listing",
            "continue_editing": "Continue editing"
        },
        "getting_started": {
            "template": "Template",
            "customization": "Customization",
            "preview_and_next_steps": "Preview & next steps",
            "preview": "Preview",
            "customize_your_website": "Customize your website",
            "customize_your_website_description": "Add your property address and photos. Don’t worry - you will be able to add more information later.",
            "add_property_address": "Add property address",
            "add_property_photos": "Add property photos",
            "i_dont_have_any_photos_with_me": "I don't have any photos with me",
            "upload_up_to_20_photos": "Upload up to 20 photos",
            "view_your_website": "View your website",
            "or_skip_this_step": "Or skip this step",
            "sign_up_to_view_your_website": "Create your first property website",
            "first_name": "First name",
            "first_name_placeholder": "John",
            "last_name": "Last name",
            "last_name_placeholder": "Doe",
            "email_address": "Email address",
            "email_address_placeholder": "johndoe@realestate.com",
            "phone_number": "Phone number",
            "phone_number_placeholder": "888 888 8888",
            "create_password": "Create password",
            "create_password_placeholder": "Min. 8 characters",
            "finish_setting_up_your_account": "Finish setting up your account",
            "and": "and",
            "by_signing_up_you_agree_to_pillars": "By signing up, you agree to Pillar's",
            "not_subscribe_text": "I do not wish to receive product updates and news about Pillar products and services.",
            "continue": "Continue",
            "sign_up": "Sign up",
            "uploading": "Uploading...",
            "compressing_photo": "Compressing photo",
            "unable_to_upload": "Unable to upload file, please try again.",
            "14_day_free_trial": "7 day free trial",
            "no_card_required": "No card required",
            "cancel_anytime": "Cancel anytime"
        },
        "validation": {
            "accepted": "The {attribute} must be accepted.",
            "active_url": "The {attribute} is not a valid URL.",
            "after": "The {attribute} must be a date after {date}.",
            "after_or_equal": "The {attribute} must be a date after or equal to {date}.",
            "alpha": "The {attribute} may only contain letters.",
            "alpha_dash": "The {attribute} may only contain letters, numbers, dashes and underscores.",
            "alpha_num": "The {attribute} may only contain letters and numbers.",
            "array": "The {attribute} must be an array.",
            "before": "The {attribute} must be a date before {date}.",
            "before_or_equal": "The {attribute} must be a date before or equal to {date}.",
            "between": {
                "numeric": "The {attribute} must be between {min} and {max}.",
                "file": "The {attribute} must be between {min} and {max} kilobytes.",
                "string": "The {attribute} must be between {min} and {max} characters.",
                "array": "The {attribute} must have between {min} and {max} items."
            },
            "boolean": "The {attribute} field must be true or false.",
            "confirmed": "The {attribute} confirmation does not match.",
            "date": "The {attribute} is not a valid date.",
            "date_equals": "The {attribute} must be a date equal to {date}.",
            "date_format": "The {attribute} does not match the format {format}.",
            "different": "The {attribute} and {other} must be different.",
            "digits": "The {attribute} must be {digits} digits.",
            "digits_between": "The {attribute} must be between {min} and {max} digits.",
            "dimensions": "The {attribute} has invalid image dimensions.",
            "distinct": "The {attribute} field has a duplicate value.",
            "email": "The {attribute} must be a valid email address.",
            "ends_with": "The {attribute} must end with one of the following: {values}",
            "exists": "The selected {attribute} is invalid.",
            "file": "The {attribute} must be a file.",
            "filled": "The {attribute} field must have a value.",
            "gt": {
                "numeric": "The {attribute} must be greater than {value}.",
                "file": "The {attribute} must be greater than {value} kilobytes.",
                "string": "The {attribute} must be greater than {value} characters.",
                "array": "The {attribute} must have more than {value} items."
            },
            "gte": {
                "numeric": "The {attribute} must be greater than or equal {value}.",
                "file": "The {attribute} must be greater than or equal {value} kilobytes.",
                "string": "The {attribute} must be greater than or equal {value} characters.",
                "array": "The {attribute} must have {value} items or more."
            },
            "image": "The {attribute} must be an image.",
            "in": "The selected {attribute} is invalid.",
            "in_array": "The {attribute} field does not exist in {other}.",
            "integer": "The {attribute} must be an integer.",
            "ip": "The {attribute} must be a valid IP address.",
            "ipv4": "The {attribute} must be a valid IPv4 address.",
            "ipv6": "The {attribute} must be a valid IPv6 address.",
            "json": "The {attribute} must be a valid JSON string.",
            "lt": {
                "numeric": "The {attribute} must be less than {value}.",
                "file": "The {attribute} must be less than {value} kilobytes.",
                "string": "The {attribute} must be less than {value} characters.",
                "array": "The {attribute} must have less than {value} items."
            },
            "lte": {
                "numeric": "The {attribute} must be less than or equal {value}.",
                "file": "The {attribute} must be less than or equal {value} kilobytes.",
                "string": "The {attribute} must be less than or equal {value} characters.",
                "array": "The {attribute} must not have more than {value} items."
            },
            "max": {
                "numeric": "The {attribute} may not be greater than {max}.",
                "file": "The {attribute} may not be greater than {max} kilobytes.",
                "string": "The {attribute} may not be greater than {max} characters.",
                "array": "The {attribute} may not have more than {max} items."
            },
            "mimes": "The {attribute} must be a file of type: {values}.",
            "mimetypes": "The {attribute} must be a file of type: {values}.",
            "min": {
                "numeric": "The {attribute} must be at least {min}.",
                "file": "The {attribute} must be at least {min} kilobytes.",
                "string": "The {attribute} must be at least {min} characters.",
                "array": "The {attribute} must have at least {min} items."
            },
            "not_in": "The selected {attribute} is invalid.",
            "not_regex": "The {attribute} format is invalid.",
            "numeric": "The {attribute} must be a number.",
            "present": "The {attribute} field must be present.",
            "regex": "The {attribute} format is invalid.",
            "required": "The {attribute} field is required.",
            "required_if": "The {attribute} field is required when {other} is {value}.",
            "required_unless": "The {attribute} field is required unless {other} is in {values}.",
            "required_with": "The {attribute} field is required when {values} is present.",
            "required_with_all": "The {attribute} field is required when {values} are present.",
            "required_without": "The {attribute} field is required when {values} is not present.",
            "required_without_all": "The {attribute} field is required when none of {values} are present.",
            "same": "The {attribute} and {other} must match.",
            "size": {
                "numeric": "The {attribute} must be {size}.",
                "file": "The {attribute} must be {size} kilobytes.",
                "string": "The {attribute} must be {size} characters.",
                "array": "The {attribute} must contain {size} items."
            },
            "starts_with": "The {attribute} must start with one of the following: {values}",
            "string": "The {attribute} must be a string.",
            "timezone": "The {attribute} must be a valid zone.",
            "unique": "The {attribute} has already been taken.",
            "uploaded": "The {attribute} failed to upload.",
            "url": "The {attribute} format is invalid.",
            "uuid": "The {attribute} must be a valid UUID.",
            "custom": {
                "attribute-name": {
                    "rule-name": "custom-message"
                }
            },
            "attributes": []
        },
        "components": {
            "schedule_showing": {
                "monday": "Monday",
                "tuesday": "Tuesday",
                "wednesday": "Wednesday",
                "thursday": "Thursday",
                "friday": "Friday",
                "saturday": "Saturday",
                "sunday": "Sunday",
                "title": "Availability for showings"
            },
            "video_tour": {
                "upload_video": "Upload videos of the property either directly from your computer, YouTube, or upload a virtual tour from services like Matterport.",
                "embed_video": "Embed video from YouTube or Vimeo",
                "video_tour": "Video & Virtual tour",
                "hd_quality": "HD quality"
            },
            "embed_virtual_tour": {
                "embed_virtual_tour": "Embed Virtual Tour",
                "add_video_link": "Virtual Tour URL",
                "video_embedded": "Video embedded",
                "failed_to_embed_video": "Failed to embed video. Please check url",
                "embed_video": "Embed Virtual Tour"
            },
            "templates": {
                "lock_listing": {
                    "title": "Continue to tour this home",
                    "full_name": "Full name",
                    "email_address": "Email address",
                    "phone_number": "Phone number",
                    "tour_this_home": "Tour this home"
                },
                "exit_intent": {
                    "title": "Before you go...",
                    "description": "Want to be the first one to get exclusive offers in your area? Sign up and save!",
                    "full_name": "Full name",
                    "email_address": "Email address",
                    "phone_number": "Phone number",
                    "get_offers": "Get offers",
                    "no_thanks": "No thanks",
                    "request_received": "Request received",
                    "we_will_send": "We will send you the best offers in your area soon",
                    "close": "Close"
                },
                "book_a_showing": {
                    "book_a_showing": "Book a Showing",
                    "appointment_type": "Appointment type",
                    "in_person": "In person",
                    "virtual_showing": "Virtual showing",
                    "appointment_date": "Appointment date",
                    "preferred_time": "Preferred time",
                    "morning": "Morning",
                    "afternoon": "Afternoon",
                    "evening": "Evening",
                    "full_name": "Full name",
                    "john_doe": "John Doe",
                    "email_address": "Email address",
                    "johndoe_realestate_com": "Johndoe@realestate.com",
                    "phone_number": "Phone number",
                    "phone_number_placeholder": "888 888 8888",
                    "additional_information": "Additional information",
                    "i_would_like_to_shedule_a_showing": "I would like to schedule a showing",
                    "confirm_booking": "Book a showing",
                    "tour_confirmed_for": "tour requested for",
                    "thanks_for_booking": "Thanks for requesting a showing. I will follow up with exact details shortly."
                }
            },
            "embed_video": {
                "add_video_link": "Add video link",
                "embed_video": "Embed video from Youtube or Vimeo",
                "video_embedded": "Video embedded",
                "failed_to_embed_video": "Failed to embed video",
                "edit_embed_video": "Edit YouTube or Vimeo video cover",
                "edit_video_link": "Edit video link",
                "as_top_section_cover": "Add this video as top section cover",
                "hd_quality": "HD quality"
            },
            "additional_documents": {
                "additional_documents": "Additional documents",
                "upload_a_file": "Upload a file",
                "or": "OR",
                "insert_a_link": "Insert a link",
                "added_documents": "Added documents",
                "edit_link": "Edit link",
                "remove": "Remove",
                "cancel": "Cancel",
                "link_url": "Link URL",
                "link_text": "Link text",
                "insert_link": "Insert",
                "edit": "Edit",
                "link_text_placeholder": "Name of the link",
                "link_url_placeholder": "https://drive.google.com/link",
                "update_a_link": "Update a link",
                "update": "Update",
                "delete_file_title": "Remove file",
                "delete_link_title": "Remove link",
                "delete_file_description": "Are you sure you want to remove this file?",
                "delete_link_description": "Are you sure you want to remove this link?",
                "change_file_title": "Change file title",
                "file_title": "File title"
            }
        },
        "landing_page": {
            "main": {
                "product": "Product",
                "pricing": "Pricing",
                "designs": "Designs",
                "contact_us": "Contact Us",
                "login": "Log in",
                "hero_title": "Build a stunning property website in under 7 minutes",
                "hero_description": "Get more listings and sell them faster by presenting properties in premium websites designed for lead generation. No developers needed.",
                "get_started_for_free": "Create for free",
                "agents_helped": "Agents helped",
                "websites_created": "Websites created",
                "plans_and_visuals_made": "Plans & Visuals made",
                "stand_out_from_the_croud": "Sell faster & win more properties",
                "make_your_listings_stnd_out": "Customize your listings to highlight the best of each property, showcase your expertise and capture leads through elegant and responsive websites.",
                "faster": "Fast",
                "faster_description": "It only takes 7 minutes to create your listing's website.",
                "cheaper": "Well-priced",
                "cheaper_description": "Only $14/month - expanding your business in a unique way shouldn't cost you more.",
                "beautiful": "Classy",
                "beautiful_description": "Constantly updated high-end responsive designs built to attract attention & generate more leads.",
                "as_easy": "As easy as filling out a form",
                "choose_a_template": "Choose a template",
                "choose_a_template_description": "Simply pick one of our handcrafted templates designed specifically for real estate listings",
                "add_listing_information": "Add listing information",
                "add_listing_information_description": "Insert listing information such as text and media into the selected template",
                "pick_a_domain": "Pick a domain",
                "pick_a_domain_description": "Once you’ve added all the information, simply click publish or select a custom domain for your website. Your listing is now live!",
                "join_hundreds": "Join hundreds of agents marketing their listings more effectively",
                "pillar_helps": "Pillar helps agents get more leads - one property at a time",
                "request_demo": "Request a demo",
                "what_our_customers_are_saying": "What our customers are saying",
                "supercharge_your_listing": "Ready to supercharge your listing?",
                "supercharge_your_listing_description": "Spend more time building your business and less time at your desk.",
                "spend_more_time_building": "Spend more time building",
                "your_business": "your business and less time at your desk.",
                "get_started_now": "Get started now",
                "full_name": "Full name",
                "email_address": "Email address",
                "company": "Company (optional)",
                "your_message": "Your message",
                "send_message": "Send message",
                "arrange_for_consultation": "Request a demo",
                "first_name": "First name",
                "last_name": "Last name",
                "job_title": "Job title",
                "company_name": "Company name",
                "phone_number": "Phone number",
                "your_message_optional": "Your message (optional)",
                "thoughtfully_crafted_designs": "Thoughtfully crafted designs",
                "our_designs": "Our designs are specifically crafted to make your property shine and help you generate leads more easily",
                "view_designs": "View designs",
                "view": "View",
                "get_started": "Try it free",
                "book_a_demo": "Book a demo",
                "create_now": "Create now",
                "free_trial_no_cc_required": "7-day free trial - then from $5/month per site. No card required",
                "see_how_it_works": "See how it works",
                "watch_our_demo": "Watch our 2min demo",
                "dont_believe_how_easy_it_is": "Don't believe how easy it is? Watch our demo walkthrough showing how to build a single property site in minutes",
                "as_seen_on": "As seen on",
                "trusted_by": "Trusted by",
                "review_1": "“It's so easy. I received a couple of new properties because I quickly built websites for them. The design is great and looks professional.”",
                "review_2": "“The most beautiful, versatile and fastest website builder for real estate I’ve ever seen. As easy as a breeze to work with, highly recommended for everyone without missing a classy touch and saving hundreds (if not thousands).”",
                "review_3": "“Pillar has set the trend for efficiently creating stylish websites that could’ve been made only by a professional web design agency. The quality of templates is where Pillar outshines its competition.”",
                "review_4": "“I quickly made a website on the platform to attract the owner’s attention and get the listing! Just heard from him that the house is mine to sell - exclusively. Cheers guys!”",
                "review_5": "“I shared my new listing site with my network and client database three days ago. As of today I had 5 potential buyers request information about the property and I already arranged a viewing with 3 of them.”"
            },
            "components": {
                "exit_intent_popup": {
                    "enter_your_email": "Enter your email and get 10% off any plan!",
                    "email_address": "Email address",
                    "yes_i_want_discount": "Yes! I want 10% Off",
                    "no_thanks": "No thanks",
                    "discount_applied": "We have applied the discount to your email - now finish signing up to use it!",
                    "finish_signing_up": "Finish signing up"
                }
            },
            "get_started": {
                "select_a_template": "Select a template",
                "select_a_template_description": "Choose one of the templates from our list where each one was made for a specific purpose. Don’t worry - you can change the template later if you want to."
            },
            "pricing": {
                "hero_title": "Affordable pricing for everyone",
                "hero_description_1": "No credit card required.",
                "hero_description_2": "All plans come with 24/7 customer support. Change or cancel your plan at any time.",
                "additional_services": "Additional services",
                "3d_plans": "3D Plans",
                "3d_plans_description": "Order a custom 3D Plan for your property based on your floorplan and requirements in 3 business days. Contact us for more details.",
                "plan": "plan",
                "visual": "visual",
                "visualizations": "Visualisations",
                "visualizations_description": "Get a highest quality visualisation made in 3 business days. Contact us for more details.",
                "faq_question_1": "Is there a free trial?",
                "faq_answer_1": "Yes, we offer a 14-day free trial for up to 5 listing sites. The free trial is fully featured.",
                "faq_question_2": "How much do single property Websites cost?",
                "faq_answer_2": "Our subscription starts at $14 per month. The more listing websites you have, the cheaper each site gets. Subscriptions are month-to-month with NO contract. You can upgrade, downgrade or cancel your plan anytime. Visit our Plans & Pricing page for more information.",
                "faq_question_3": "How much do custom domains cost?",
                "faq_answer_3": "We offer custom domains for $15 - You can purchase a domain directly from Pillar.",
                "faq_question_4": "What if I reach my listing limit?",
                "faq_answer_4": "If you reach your listing limit you can upgrade to a larger plan with a higher limit.",
                "faq_question_5": "Why would I choose the annual plan?",
                "faq_answer_5": "We offer 15% off the monthly price when you pay for 12 months up-front. It’s a great option if you like discounts!",
                "faq_question_6": "Can I upload and display files on my websites such as floor plans, documents, videos?",
                "faq_answer_6": "Yes. We've got you covered! You can add documents to every single property website.",
                "faq_question_7": "Can I display 3D virtual tours on my single property websites?",
                "faq_answer_7": "Yes, you will be surprised how simple that is.",
                "faq_question_8": "When a property sells can I remove it to make room for another website?",
                "faq_answer_8": "Yes! You can delete a property site once it’s sold and you’ll have room for another one. You can have as many websites as your subscription plan allows.",
                "whats_included": "What’s included",
                "coming_soon": "Coming soon",
                "faq": "Frequently asked questions",
                "mobile_first": "Mobile first",
                "free_subdomain": "Free subdomain",
                "free_hosting": "Free hosting",
                "messenger_live_chat": "Messenger live chat",
                "buy_a_unique_domain": "Buy a unique domain",
                "upload_docs_and_links": "Upload docs & links",
                "integrate_virtual_tour": "Integrate virtual tour",
                "upload_videos_and_floor_plans": "Upload videos & floor plans",
                "free_ssl_certificates": "Free SSL certificates",
                "google_maps": "Google maps",
                "facebook_pixel": "Facebook Pixel",
                "share_to_social_media": "Share to social media",
                "schedule_a_showing": "Schedule a showing",
                "seo_optimized": "SEO Optimized",
                "mls_unbranded_version": "MLS unbranded version",
                "leave_intent_capture": "Leave intent capture",
                "set_as_just_listed": "Set as just listed, price reduced, pending, sold",
                "unlock_listing_capture": "“Unlock listing” capture",
                "add_open_house_times": "Add open house times",
                "coming_soon_lead_capture": "“Coming soon” lead capture",
                "listing_website_analytics": "Listing website analytics"
            },
            "designs": {
                "hero_title": "Designs that help you stand out",
                "hero_description": "Specifically designed for showcasing properties, generating leads and selling faster. Select a template and create your free website in minutes"
            }
        },
        "pixel": {
            "title": "Add Facebook Pixel",
            "description": "Add your Facebook Pixel code to collect data that helps you track conversions from Facebook ads for all of your Pillar listings.",
            "add_easy": "Adding a Pixel ID is quite easy:",
            "first_step": "copy your Facebook Pixel ID you want to use for our sites",
            "first_step_more": "If you don’t have one, follow Facebook’s steps to",
            "first_step_link_title": "create your first Pixel",
            "second_step": "paste your Pixel ID below and press Save ID. You’re done!",
            "third_step": "We have already set up all conversion events on our templates so you will start seeing events as soon as you add the base code.",
            "add_your_pixel_code": "Add yout Pixel base code",
            "add_your_pixel_code_placeholder": "<!-- Facebook Pixel Code -->\n    <script>\n      !function(f,b,e,v,n,t,s)\n      {if(f.fbq)return;n=f.fbq=function(){n.callMethod?\n      n.callMethod.apply(n,arguments){n}.queue.push(arguments)};\n      if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';\n      n.queue=[];t=b.createElement(e);t.async=!0;\n      t.src=v;s=b.getElementsByTagName(e)[0];\n      s.parentNode.insertBefore(t,s)}(window, document,'script',\n      'https://connect.facebook.net/en_US/fbevents.js');\n      fbq('init', '288089709022004');\n      fbq('track', 'PageView');\n    </script>\n    <noscript><img height=\"1\" width=\"1\" style=\"display{none}\"\n      src=\"https://www.facebook.com/tr?id=288089709022004&ev=PageView&noscript=1\"/></noscript>\n    <!-- End Facebook Pixel Code -->",
            "save_code": "Save Code"
        },
        "pricing": {
            "choose_a_plan": "Choose a plan",
            "choose_a_plan_description": "All plans come with 24/7 customer support. Change or cancel your plan at any time.",
            "monthly": "Monthly",
            "yearly": "Yearly",
            "save_15_percent": "Save 15%",
            "starter": "Starter",
            "advanced": "Advanced",
            "professional": "Professional",
            "professional_30": "Professional 30",
            "professional_60": "Professional 60",
            "professional_120": "Professional 120",
            "enterprise": "Enterprise",
            "mo": "mo",
            "starter_description": "Create 1 listing website for your special property",
            "advanced_description": "Create up to 5 listing sites at a time",
            "professional_description": "Create up to 15 listing sites at a time",
            "professional_30_description": "Upgrade your professional plan to create up to 30 listing sites",
            "professional_60_description": "Upgrade your professional plan to create up to 60 listing sites",
            "professional_120_description": "Upgrade your professional plan to create up to 120 listing sites",
            "enterprise_description": "Advanced features for teams, with custom branding & more",
            "enterprise_feature_1": "Unlimited listings",
            "enterprise_feature_2": "Advanced security",
            "enterprise_feature_3": "Permissions & workflows",
            "select": "Select",
            "current_plan": "Current plan",
            "plan": "plan",
            "billed": "Billed",
            "total_billed": "Total billed",
            "upgrade_my_plan": "Upgrade my plan",
            "contact_us": "Contact us",
            "order_summary": "Order summary",
            "renew_successful": "Renew successful",
            "back_to_dashboard": "Back to dashboard",
            "add_another_listing": "Add another listing",
            "lets_finish_upgrading": "Let's finish upgrading",
            "plan_is_right_for_you": "plan is right for you",
            "upgrade_successful": "Upgrade successful",
            "starter_monthly_price": "12",
            "starter_yearly_price": "10",
            "advanced_monthly_price": "42",
            "advanced_yearly_price": "36",
            "professional_monthly_price": "84",
            "professional_yearly_price": "72",
            "3d_plan_price": "99",
            "visual_price": "399",
            "other_plans": "Other plans",
            "advanced_monthly_per_site": "8.4",
            "advanced_yearly_per_site": "7.2",
            "professional_monthly_per_site": "5.6",
            "professional_yearly_per_site": "4.8",
            "professional_30_monthly_per_site": "3.4",
            "professional_30_yearly_per_site": "2.9",
            "professional_60_monthly_per_site": "2.9",
            "professional_60_yearly_per_site": "2.5",
            "professional_120_monthly_per_site": "2.5",
            "professional_120_yearly_per_site": "2.1",
            "per_site_month": "per site /mo",
            "per_additional_site_month": "per additional site /mo"
        },
        "listing_published": {
            "listing_published": "Listing published",
            "congratulations": "Congratulations",
            "your_listing": "Your listing website was published. Now go ahead and share it to get new leads!",
            "view_live_website": "View live website",
            "dashboard": "Dashboard",
            "copy_link": "Copy link"
        }
    },
    "lt": {
        "auth": {
            "login": {
                "welcome": "Sveiki,",
                "login_to_continue": "Prisijunkite prie sistemos",
                "your_email": "El. paštas",
                "your_email_placeholder": "vardenis@imone.lt",
                "your_password": "Slaptažodis",
                "your_password_placeholder": "Įrašykite slaptažodį",
                "login": "Prisijungti",
                "dont_have_an_account": "Neturite paskyros?",
                "sign_up_for_free": "Pradėkite už dyką",
                "forgot_password": "Užmiršote slaptažodį?",
                "failed": "Patikrinkite prisijungimo duomenis",
                "log_into_pillar": "Log into Pillar",
                "or": "or",
                "continue_with_google": "Continue with Google",
                "continue_with_facebook": "Continue with Facebook",
                "continue_with_email": "Continue with email"
            },
            "change_password": {
                "enter_new_password": "Įveskite naują slaptažodį",
                "new_password": "Naujas slaptažodis",
                "password_placeholder": "Įrašykite slaptažodį",
                "confirm_new_password": "Pakartokite naują slaptažodį",
                "set_new_password": "Patvirtinti naują slaptažodį",
                "take_me_back_to_login_screen": "Nuveskite atgal į prisijungimo langą"
            },
            "reset_password": {
                "reset_password": "Atkurti slaptažodį",
                "reset_password_description": "Mes galime jums padėti atkurti jūsų slaptažodį naudodami el. pašto adresą kurį naudojote registracijoje.",
                "your_email": "El. paštas",
                "your_email_placeholder": "vardenis@imone.lt",
                "reset_my_password": "Atkurti mano slaptažodį",
                "take_me_back_to_login_screen": "Nuveskite atgal į prisijungimo langą"
            }
        },
        "listing_form": {
            "listing_template": {
                "select_a_template": "Pasirinkite šabloną",
                "choose_one": "Pasirinkite vieną iš šablonų. Kiekvienas šablonas sukurtas skirtingo stiliaus objektams. Nesijaudinkite - jūs taip pat galėsite pasikeisti šabloną vėliau.",
                "select": "Pasirinkti",
                "select_template": "Paleisti svetainę",
                "preview": "Peržiūrėti",
                "selected": "Pasirinktas",
                "baroque": "Barokinis",
                "this_sophisticated": "Šis rafinuotas dizainas gali būti naudojamas įvairiems objektams ir geriausiai tinka klasikiniam nekilnojamajam turtui.",
                "modernist": "Modernistinis",
                "minimalist_template": "Minimalistinis dizainas padeda žiūrovams sutelkti dėmesį į turinį - labiausiai tinka naudoti modernistinėms objektams ar skelbimams su aukštos kokybės nuotraukomis.",
                "gothic": "Gotikinis",
                "this_unique": "Šis unikalus šablonas padės dar labiau išsiskirti dėl tamsaus dizaino. Tinka įvairiems objektams.",
                "byzantine": "Bizantinis",
                "cozy_and": "Jaukus ir draugiškas visada laimi žaidimą. Šis lengvas ir žaismingas dizainas jūsų objektą pavers dar jaukesnę.",
                "art_deco": "Art Deco",
                "thanks_to": "Dėl mėlynų akcentų šis šablonas labiausiai tinka objektams, kurios turi parodyti pasitikėjimą. Puikiai tinka komerciniam NT.",
                "most_popular": "Populiariausias",
                "victorian": "Victorian",
                "our_most": "Our most universal template that works for any type of property. Make your listing look more elegant with hunter green color accents."
            },
            "listing_photos": {
                "review_and_add_more_photos": "Pridėkite objekto nuotraukas",
                "upload_photos_description": "Įkelkite objekto nuotraukas, kurias norite publikuoti.",
                "upload_photos": "Įkelkite nuotraukas",
                "upload_more_photos": "Įkelkite daugiau nuotraukų"
            },
            "help_popup": {
                "information_about_the_location": "Informacija apie vietovę",
                "information_about_the_location_description": "Informacija apie vietovę: Čia jūs galite pateikti informaciją susijusią su vietove kurioje randasi jųsų objektas – Ši svetainės dalis bus rodoma šalia žemėlapio, “Vietovės” dalyje.",
                "top_section_title": "Viršutinės dalies pavadinimas",
                "top_section_description": "Tai yra pirmoji informacijos dalis kurią lankytojai mato atsidarydami jūsų internėtinė svetainę. Mes rekomenduojame trumpą ir lengvai įsimenama frazę ",
                "top_section_square_footage": "Kvadratūra ir kaina",
                "top_section_square_footage_description": "Įveskite objekto kvadratūrą ir kainą.",
                "top_section_beds_and_baths": "Kambariai",
                "top_section_beds_and_baths_description": "Įveskite kiek kambarių ir vonios kambarių yra objekte.",
                "top_section_hero_image": "Viršutinės dalies nuotrauka (arba video) ",
                "top_section_hero_image_description": "Pasirinkite gražiausią objekto nuotrauka kuri bus rodoma puslapio fone - mes siūlome kelti kuo geresnės kokybės nuotrauką.",
                "top_section_logo": "Įmonės logo",
                "top_section_logo_description": "Įkelkite savo arba kompanijos logo ",
                "overview_title_and_text": "Aprašymas",
                "overview_title_and_text_description": "Papasakokite daugiau apie objektą, kad skaitytojas geriau susipažintu su juo. Pritraukite dar daugiau dėmesio pridedami antraštę",
                "overview_images": "Aprašymo nuotraukos",
                "overview_images_description": "Pasirinkite gražiausias nuotraukas kurias norėtumėte rodyti prie aprašymo, atskirai nuo likusių nuotraukų.",
                "amenities": "Objekto ypatybės",
                "amenities_description": "Pridėkite savo objekto savybes norint pritraukti lankytojo dėmesį. Paprasčiausiai įveskite žodį  ir paspauskite Enter.",
                "listing_photos": "Objekto nuotraukos",
                "listing_photos_description": "Čia rodomos visos objekto nuotraukos kurias įkėlėte.",
                "floor_plans": "Namo planas",
                "floor_plans_description": "Namo planai - ypač 3D - padeda geriau suprasti objektą ir jo išdėstymą, pakeliant peržiūrų skaičių. Jeigų turite tik paprastą aukštų įšplanavimo planą ir noritę jį paversti į 3d, susisiekite su mumis ir mes jums padėsime.",
                "share_a_bit_about_yourself": "Pristatykite save",
                "share_a_bit_about_yourself_description": "Leiskite puslapio naršytojams sužinoti daugiau apie save - pasidalinkite keliais sakiniais apie save ir jūsų patirtį",
                "add_your_social_media_links": "Pridėkite savo socialinės medios nuorodas",
                "add_your_social_media_links_description": "Leiskite internetinio puslapio lankytojiems susirasti jus socialinių tinklų puslapiuose  tiesiog perkopijuojant  nuorodą nuo jūsų socialinės medijos profilio. Šias nuorodas jūs galite gauti tiesiog  atidarius  viena iš jūsų turimų socialinės medijos profilių, ir nukopijavus nuorodą nuo savo naršyklės.",
                "video_tour": "Įkelti objekto video",
                "video_tour_description": "Įkelkite objekto video ir mes jį rodysime puslapyje tarp Objekto Ypatybių ir Nuotraukų sekcijų",
                "listing_agent_title": "Objekto atstovas",
                "listing_agent_description": "Jei jūs nesate tiesioginis objekto pardavimų atstovas, šioje skiltyje rekomenduojama nurodyti jo informaciją.",
                "co_agent_title": "Pridėti papildomą agentą.",
                "co_agent_description": "Publikuojate šį objektą kartu su kitu agentu? Pridėkite papildomo agento informaciją. Ją matysite \"agento\" dalyje.",
                "schedule_showing": "Leiskite jūsų puslapio lankytojams susitarti apžiūros laiką.",
                "schedule_showing_description": "Gaukite daugiau potencialių pirkėjų leisdami jiems suderinti su jumis gyvą ar online apžiūrą. Nustatykite valandas, kuriomis puslapio lankytojai gali su jumis suderinti apžiūrą. Klientui pasirinkus apžiūros laiką jus informuosime el. paštu.",
                "messenger": "Messenger live chat",
                "messenger_description": "Gaukite daugiau potencialių objekto pirkėjų su Facebook Messenger live chat pagalba, kurį galite lengvai sujungti su objekto puslapiu. Jūs tik turite turėti Facebook puslapį. (ne asmeninę anketą).",
                "additional_documents": "Pridėkite papildomus dokumentus",
                "additional_documents_description": "Įkelkite dokumentus kuriuos norite parodyti savo potencialiems pirkėjams. Taip pat galite įkelti nuorodas į failus kurie patalpinti išorinėse talpyklose.<br> Palaikomi failų tipai: PDF, DOC, XLS, CSV, ODT, TXT.",
                "as_top_section_cover_title": "Add video as top section cover",
                "as_top_section_cover_description": "You can also Include this video at the top of the website instead of a photo  - it will be the first thing visitors see.",
                "exit_intent_popup": "Rodyti Iššokantį langelį paliekantiems puslapį",
                "exit_intent_popup_description": "Gaukite daugiau klientų kontaktų su iššokančiu langeliu, kuomet puslapio lankytojas nori uždaryti jūsų puslapį. Iššokančiame langelyje yra prašoma lankytojo palikti savo kontaktinę informaciją, kad galėtų gauti išskirtinius jūsų pasiūlymus. Pasinaudoję šiuo įrankiu galite kontaktuoti su objekto interesantais.",
                "lock_listing": "Galimybė peržiūrėti jūsų puslapį tik po registracijos.",
                "lock_listing_description": "Norėdami išrinkti tik labai susidomėjusius lankytojus, galite neleisti lankytojui peržiūrėti jūsų puslapio kol lankytojas nenurodė savo el. pašto. ( arba facebook prisijungimu). Pastaba : lankytojai, kurie neprisijungs, jūsų puslapio peržiūrėti negalės.",
                "listing_status": "Objekto statusas",
                "listing_status_description": "Pakeiskite objekto statusą. Pasirinkdami skirtingus statusus galite informuoti klientus apie etapus, kuriame šiuo metu yra objektas.",
                "display_more_listings": "Display more listings",
                "display_more_listings_description": "Let your website visitors discover other listings you have on Pillar by showcasing them at the bottom of the website. Other listings you have on Pillar will be shown in the “More listings” section.",
                "change_colors": "Change template colors",
                "change_colors_description": "Change the colors of the selected template to make your property website even more unique. Choose from recommended colors, which are compatible with both light and dark modes. You can also use a custom color by entering it’s HEX codes. We do not recommend using the “Custom” option, because it can make the property website look low-quality."
            },
            "agent_details": {
                "add_agent_details": "Pridėti agento informaciją",
                "fill_in": "Surašykite savo kontaktinius duomenys, kad lankytojai žinotų apie asmenį, pristatantį objektą.",
                "agent_profile_photo": "Profilio nuotrauka",
                "upload_an_image": "Įkelti nuotrauką",
                "full_name": "Pilnas vardas",
                "full_name_placeholder": "Vardenis Pavardenis",
                "occupation": "Pareigos",
                "occupation_placeholder": "NT agentas, brokeris, vystytojas",
                "contact_email": "Kontaktinis el. paštas",
                "contact_email_placeholder": "johndoe@company.com",
                "company": "Įmonė",
                "company_placeholder": "Agentūra",
                "website": "Įmonės puslapis",
                "website_placeholder": "agentura.lt",
                "mobile_phone_number": "Mobilus tel. nr.",
                "mobile_phone_number_placeholder": "+3706 0000 000",
                "share_a": "Pristatykite save",
                "share_a_placeholder": "pvz.: Vardenis turi daugiau nei 15 metų komercinės ir gyvenamosios nekilnojamo turto patirties. Jis yra vienas iš itakingiausių agentų Vilniuje. Kaip vienas iš įkurėjų naujosios NT įmonės, Vardenis padėjo šimtams pirkėjų rasti idealius namus.",
                "social_media_links": "Socialinės medijos nuorodos",
                "copy_paste": "Pridėkite savo socialinės medijos nuorodas kad vartotojai matytų.",
                "make_website_unbranded": "Make website unbranded",
                "co_agent": "Pridėti papildomą agentą.",
                "co_agent_profile_photo": "Papildomo agento nuotrauka",
                "co_agents_company": "Papildomo agento agentūra",
                "co_agents_website": "Papildomo agento agentūros puslapis",
                "listing_agent": "Objekto atstovas",
                "listing_agent_profile_photo": "Objekto atstovo nuotrauka",
                "listing_agent_full_name": "Objekto atstovo pilnas vardas",
                "listing_agent_occupation": "objekto atstovo pozicija",
                "listing_agent_contact_email": "objekto atstovo el. paštas",
                "listing_agent_company": "Objekto atstovo agentūra",
                "listing_agent_website": "objekto atstovo agentūros puslapis",
                "listing_agent_mobile_phone_number": "objekto atstovo kontaktinis numeris"
            },
            "crop": {
                "crop_and_resize_photo": "Apkirpti nuotrauką",
                "adjust_your": "Sureguliuokite savo nuotrauką, kad ji atrodytų geriau ant jūsų pasirinkto šablono",
                "crop": "Kirpti"
            },
            "listing_details": {
                "edit_listing_address": "Pridėti objekto adresą",
                "we_will": "Mes panaudosime šią informaciją rasti objektą žemėlapyje ir parodyti jį lankytojams",
                "find_your": "Ieškoti adreso",
                "type_address": "Įveskite adresą čia",
                "country": "Šalis",
                "street": "Gatvė",
                "city": "Miestas",
                "state": "Valstija",
                "region_county": "Regionas / Apskritis",
                "postal_code": "Pašto kodas",
                "zip_code": "Zip kodas",
                "information_about": "Informacija apie vietovę",
                "continue": "Toliau",
                "information_about_placeholder": "pvz.: Pristatome Jums gyvenvietės pirmąjį etapą, kuris ypatingai bus pamėgtas žmonių, kurie vertina gamtą bei ramybę. Vakarinis aplinkelis užtikrina puikų susisiekimą su miesto centru bei miegamaisiais rajonais, tiek nuosavu automobiliu, tiek viešuoju transportu.",
                "select_country": "Pasirinkite šalį"
            },
            "progress_bar": {
                "template": "Šablonas",
                "address": "Addresas",
                "agent": "Agentas",
                "photos": "Nuotraukos",
                "remaining_info": "Likusi info",
                "domain": "Pavadinimas"
            },
            "remaining_details": {
                "add_remaining_information": "Pridėkite likusią informaciją",
                "finish_adding": "Užbaikite kelti likusią informaciją apie objektą - jūs beveik pabaigėte!",
                "selected_subdomain": "Svetainės adresas",
                "selected_domain": "Svetainės adresas",
                "change": "Keisti",
                "top_section": "Svetainės viršutinė dalis",
                "title": "Pavadinimas objektui",
                "title_placeholder": "Prestižiškas butas miesto centre",
                "bedrooms": "Kambariai",
                "bathrooms": "Vonios kambariai",
                "square_footage": "Kvadratinės pėdos",
                "square_meters": "Plotas M²",
                "price": "Kaina",
                "currency": "Valiuta",
                "top_section_cover": "Viršutinės dalies nuotrauka (arba video) ",
                "company_logo": "Įmonės logo",
                "upload_logo": "Įkelti logo",
                "select_from_uploads": "Pasirinkti iš įkeltų",
                "transparent_background_recommended": "(rekomenduojame permatomą)",
                "change_photo": "Pakeisti nuotrauką",
                "crop_and_resize": "Apkirpti nuotrauką",
                "description": "Aprašymas",
                "description_title": "Aprašymo antraštė (nebūtinas)",
                "description_title_placeholder": "Geriausias kainos ir kokybės santykis",
                "describe_your_property": "Aprašykite objektą",
                "describe_your_property_placeholder": "Užmiestyje pastatytas namas kokio dar neteko matyti Vilniuje. Jeigu jūs ieškote erdvių namų, lengvo ir inteligentiško dizaino, jūs juos radote. \nTai pagal užsakymą pastatytas, visiškai naujas namas kuris negaili nieko savo detalėmis ir meistriškumui. Tai yra meistriškai sukurta gyvenamoji vieta kurios kiekvienas statymo aspektas buvo atidžiai prižiūrėtas profesionalų. Suprojektuotas Asa Barak Studio, šį namą pateikia puošnios, vandeniui atsparios Petersen plytos.",
                "description_images": "Aprašymo nutoraukos",
                "select_1st_favorite": "Pasirinkite pirmą nuotrauką",
                "select_2nd_favorite": "Pasirinkite antrą nuotrauką",
                "floor_plans": "Namo planai",
                "floor_plan_images": "Namo plano nuotraukos",
                "upload_floor_plans": "Įkelti namo planą",
                "amenities": "Objekto ypatybės",
                "amenities_description": "Pridėkite objekto ypatybes iš sąrašo arba įrašykite patys",
                "add_custom_amenities": "Pridėkite ypatybes patys",
                "add": "Pridėti",
                "rooms": "Interjeras",
                "floor_covering": "Grindų danga",
                "indoor_features": "Vidus",
                "building_and_exterior": "Pastatas ir Eksterjeras",
                "architectural_style": "Architectūrinis stilius",
                "exterior": "Eksterjeras",
                "roof": "Stogas",
                "view": "Vaizdas",
                "outdoors_and_parking": "Išorė ir Parkingas",
                "parking": "Parkingas",
                "features": "Funkcijos",
                "outdoor_amenities": "Lauko patogumai",
                "expand": "Išskleisti",
                "utilities": "Komunalinės paslaugos",
                "cooling": "Aušinimas",
                "heating": "Šildymas",
                "publish": "Paskelbti",
                "preview_website": "Peržiūrėti puslapį",
                "breakfast_nook": "Virtuvės sala",
                "dining_room": "Valgomasis",
                "family_room": "Šeimos kambarys",
                "laundry_room": "Skalbiamasis",
                "library": "Biblioteka",
                "master_bath": "Pagrindinė vonia",
                "mud_room": "Sandėlys",
                "office": "Biuro kambarys",
                "pantry": "Sandėlys",
                "recreation_room": "Poilsio kambarys",
                "workshop": "Dirbtuvės",
                "solarium_atrium": "Atriumas",
                "sun_room": "Saulės kambarys",
                "walk_in_closet": "Įeinama spinta",
                "carpet_floor": "Kiliminės grindys",
                "concrete_floor": "Betoninės grindys",
                "hardwood_floor": "Kietmedžio grindys",
                "laminate_floor": "Laminuotos grindys",
                "linoleum_vinyl_floor": "Linoleumas",
                "slate_floor": "Skalūno grindys",
                "softwood_floor": "Medinės grindys",
                "tile_floor": "Plytelių grindys",
                "attic": "Palėpė",
                "cable_ready": "Paruošta kabeliams",
                "ceiling_fans": "Lubų ventiliatoriai",
                "double_pane_windows": "Dvigubo stiklo langai",
                "fireplace": "Laužavietė",
                "intercom": "Domofonas",
                "jetted_tub": "Sūkurinė vonia",
                "security_system": "Apsaugos sistema",
                "skylights": "Stoglangiai",
                "wired": "Pravedžioti kabeliai",
                "bungalow": "Vasarnamis",
                "cape_cod_style": "Cape cod stilius",
                "modern_style": "Modernus stilius",
                "victorian_style": "Victorijos laikų stilius",
                "colonial_style": "Kolonijinis stilius",
                "ranch_rambler": "Ranča",
                "contemporary_style": "Šiuolaikinis stilius",
                "spanish_style": "Ispaniškas stilius",
                "french_style": "Prancūziškas stilius",
                "georgian_style": "Gruziniškas stilius",
                "loft": "Loftas",
                "tudor": "Tudor stilius",
                "brick_exterior": "Plytų eskterjeras",
                "cement_concrete_exterior": "Cemento / betono eskterjeras",
                "composition_exterior": "Kompozito eskterjeras",
                "metal_exterior": "Metalo  eskterjeras",
                "stone_exterior": "Akmens eskterjeras",
                "wood_wood_product_exterior": "Medienos  eskterjeras",
                "vinyl_exterior": "Plastikiniu lenteliu  eskterjeras",
                "stucco_exterior": "Tinko eskterjeras",
                "asphalt_roof": "Asfalto stogas",
                "built_up_roof": "Įmontuotas stogas",
                "composition_roof": "Kompozito stogas",
                "metal_roof": "Metalinis stogas",
                "shake_shingle_roof": "Skardinis stogas",
                "slate_roof": "Čerpinis stogas",
                "tile_roof": "Bituminis stogas",
                "city_view": "Miesto vaizdas",
                "mountain_view": "Miško vaizdas",
                "park_view": "Parko vaizdas",
                "territorial_view": "Vaizdas į teritoriją",
                "water_view": "Vandens vaizdas",
                "no_parking": "Nėra parkingo",
                "off_street_parking": "Parkingas už gatvės ribų",
                "on_street_parking": "Parkingas ant gatvės",
                "garage_detached": "Garažas - atskirtas",
                "garage_attached": "Garažas",
                "carport_parking": "Automobilių stovėjimo aikštelė",
                "gated_entry": "Uždaras kiemas",
                "basketball_court": "Krepšinio aikštė",
                "near_transportation": "Arti stotelės",
                "controlled_access": "Kontruoliuojamas prieinamumas",
                "sports_court": "Sporto klubas",
                "childrens_playground": "Vaikų žaidimo aikštelė",
                "tennis_court": "Teniso aikštė",
                "elevator": "Liftas",
                "doorman": "Durininkas",
                "balcony_patio": "Balkonas",
                "hot_tub_spa": "Lauko jacuzzi",
                "greenhouse": "Šiltnamis",
                "garden": "Sodas",
                "fenced_yard": "Aptvertas kiemas",
                "dock": "Denis / platforma",
                "deck": "Prieplauka",
                "barbecue_area": "Lauko kepimo vieta",
                "lawn": "Žolytė",
                "pond": "Tvenkinys",
                "pool": "Baseinas",
                "porch": "Veranda",
                "sauna": "Sauna",
                "central_cooling": "Central aušinimas",
                "solar_cooling": "Saulės aušinimas",
                "evaporative_cooling": "Aušinimas garais",
                "geothermal_cooling": "Geoterminis aušinimas",
                "refrigeration": "Šaldymas",
                "ac": "Oro kondicionierius",
                "coal_heating": "Pečius",
                "electric_heating": "Elektrinis šildymas",
                "gas_heating": "Dujinis šildymas",
                "oil_heating": "Tepalinis šildymas",
                "propane_butane_heating": "Propano / butano šildymas",
                "wood_pellet_heating": "Šildymas malkomis",
                "solar_heating": "Šildymas saule",
                "classical_style": "Klasikinis stilius",
                "recuperation_system": "Rekuperacinė sistema",
                "central_heating": "Centrinis šildymas",
                "liquid_fuel_heating": "Šildymas skystu kuru",
                "central_collector": "Centrinis-kolektorinis šildymas",
                "geothermal_heating": "Geoterminis šildymas",
                "solid_fuel_heating": "Šildymas kietu kuru",
                "change_top_section_image": "Pasirinkite titulinę nuotrauką",
                "change_top_section_image_description": "Pasirinkite vieną nuotrauką kuri bus rodoma puslapio viršutinės dalies fone - tai bus pats pirmas dalykas, kurį pastebės lankytojai atidarę svetainę. Norite pridėti naują nuotrauką? Nueikite į “Nuotraukos” dalį ir įkelkite ten.",
                "change_description_image": "Pasirinkite aprašymo nuotrauką",
                "change_description_image_description": "Select one of the photos to be shown together with the website description",
                "back_to_editing": "Atgal į kūrimą",
                "you_are_almost_done": "Jūs beveik pabaigėte!",
                "you_are_almost_done_text": "Pasirinkite svetainės domeną ir pasidalinkite svetaine su pasauliu",
                "select_domain": "Pasirinkti adresą",
                "interior": "Interjeras",
                "property_title_is_missing": "Trūksta objekto pavadinimo",
                "description_text_is_missing": "Trūksta objekto aprašymo",
                "messenger": "Messenger live chat",
                "connect_facebook_page": "Sujunkite savo Facebook puslapį su objekto puslapiu ir leiskite klientams bendrauti su jumis realiu laiku messenger live chat pagalba. Messenger live chat bus aktyvus tik aktyvavus objekto puslapį.",
                "select_facebook_page": "Pasirinkite puslapį",
                "connect_with_facebook": "Jungtis per Facebook",
                "select_a_page": "Pasirinkite puslapį",
                "just_listed": "Naujas objektas",
                "price_reduced": "Sumažinta kaina",
                "pending": "Rezervuotas",
                "sold": "Parduotas",
                "active": "Aktyvus",
                "no_status": "Be statuso",
                "exit_intent_popup": "Rodyti Iššokantį langelį paliekantiems puslapį",
                "capture_more_leads": "Gaukite daugiau klientų kontaktų pasinaudodami Iššokančiu langeliu (pop - up) , kuris atsiranda, kuomet puslapio lankytojas nori uždaryti puslapį.",
                "visitors_have_to_signup": "Puslapio lankytojai privalo užsiregistruoti su savo el. paštu, kad galėtų peržiūrėti jūsų objekto puslapį. ",
                "view_after_signup": "Galimybė peržiūrėti jūsų puslapį tik po registracijos.",
                "listing_status": "Objekto statusas",
                "display_more_listings": "Display more listings",
                "display_more_listings_description": "Let your website visitors discover other listings you have on Pillar with an additional “More listings” section.",
                "change_colors": "Change colors",
                "change_colors_description": "Customise your property website with different colors",
                "choose_color": "Choose one of the recommended colors below, which are compatible with both light and dark modes. You can also use a custom color by entering its HEX code.",
                "button_color": "Button color",
                "accent_color": "Accent color",
                "custom": "Custom"
            },
            "select_domain": {
                "select_domain": "Pasirinkite svetainės adresą",
                "choose_from": "Išsirinkite iš pačių geriausių NT adresatų. Nuo €14 - viskas įskaičiuota.",
                "use_our_subdomain": "Naudoti subdomeną - nemokama",
                "always_free": "Visada nemokama",
                "or_buy": "Pirkti svetainės adresą",
                "search": "ieškoti",
                "get_the_perfect_domain": "Raskite tobulą adresą",
                "view_other_domains": "Rodyti kitus adresus",
                "show_country_domains": "Rodyti šalių domenus",
                "unavailable": "Užimtas",
                "checkout": "Pirkti",
                "payment_details": "Pirkimo informacija",
                "your_payment_was_successful": "Apmokėta sėkmingai",
                "congratulations": "Sveikiname! Jūsų objekto svetainė bus matoma adresu",
                "grab_a_coffee": "Pasidarykite kavos ir atsipalaiduokite -  mes keliame visą informaciją į naujajį adresą ir tai bus paruošta per valandą. ",
                "in_the_meantime": "Kol laukiate, galite pasirinkti paviešinti svetainę dabar arba grįžti į kūrimą.",
                "publish_website": "Paviešinti svetainę",
                "back_to_editing": "Grįžti į kūrimą",
                "simply_enter_the_name": "Tiesiog įveskite subdomeno pavadinimą ir paspauskite pasirinkti",
                "select_free_subdomain": "Pasirinkti nemokamą",
                "your_domain": "Jūsų domenas",
                "you_are_owner_of": "Jūs esate",
                "domain": "domeno",
                "for_this_listing": "savininkas šiam puslapiui",
                "the_domain_you_bought_is": "Domenas, kurį nusipirkote, yra",
                "please_contact_our_support": "Susisiekite su mumis, jeigu panorėtumėte pakeisti į kitą domeną.",
                "view_live_website": "Peržiūrėti svetainę",
                "go_to_dashboard": "Grįžti į pagrindinį",
                "selected": "Pasirinktas",
                "selected_free_subdomain": "Pasirinktas nemokamas"
            }
        },
        "dashboard": {
            "your_listings": "Jūsų objektai",
            "upgrade": "Pasirinkti",
            "upgrade_to_create_another_listing": "Pasirinkite kitą planą norėdami kurti daugiau svetainių",
            "upgrade_plan": "Pakeisti planą",
            "account_settings": "Paskyros nustatymai",
            "contact_support": "Susiekite su mumis",
            "facebook_pixel": "Facebook Pixel",
            "logout": "Atsijungti",
            "edit": "Redaguoti",
            "draft": "Nepaskelbtas",
            "published": "Paskelbtas",
            "create_new_listing": "Sukurti naują svetainę",
            "unpublish": "Paslėpti",
            "unpublish_text": "Ar tikrai norite paslėpti šį puslapį? Puslapis taps nematomas puslapio lankytojams",
            "unpublish_website": "Paslėpti puslapį",
            "delete": "Ištrinti",
            "delete_text": "Ar tikrai norite ištrinti šį puslapį?",
            "delete_website": "Ištrinti puslapį",
            "duplicate": "Kopijuoti",
            "duplicate_listing": "Kopijuoti",
            "duplicate_text": "Ar tikrai norite kopijuoti puslapį?",
            "listing_duplicated": "Puslapis nukopijuotas",
            "unable_to_duplicate": "Nepavyko nukopijuoti. Atnaujinkite planą, kad galėtumėte sukurti daugiau puslapių",
            "no_status": "No status",
            "just_listed": "Just listed",
            "active": "Active",
            "price_reduced": "Price reduced",
            "pending": "Pending",
            "sold": "Sold",
            "view_analytics": "Peržiūrėkite analizę",
            "search_address": "Ieškokite adreso",
            "filter": "Filtras",
            "created": "Sukurta",
            "visit": "Apsilankykite"
        },
        "templates": {
            "sections": {
                "additional_files": {
                    "download_file": "Atsisiųsti failą",
                    "link": "Nuoroda",
                    "open_link": "Atidaryti nuorodą"
                }
            },
            "1": {
                "amenities": {
                    "1": "Aukštos lubos",
                    "2": "Grindinis šildymas",
                    "3": "Arti mokyklos",
                    "4": "Dujinis šildymas",
                    "5": "Didelė virtuvė",
                    "6": "Dveji garažai",
                    "7": "Naujos staybos",
                    "8": "Įeinamos spintos",
                    "9": "Atviros konstrukcijos",
                    "10": "Privatus",
                    "11": "Panoraminiai langai",
                    "12": "Pirtis",
                    "13": "Erdvi terasa",
                    "14": "Vidinis kiemas",
                    "15": "Arti prekybos centro"
                },
                "country": "Lietuva",
                "title": "Prabangus namas Valakampiuose",
                "overview_title": "Gyvenk skoningai",
                "overview_description": "Parduodamas naujos statybos, modernus, 2 aukštų namas Nugaletoju g., Valakampiuose.\n\n  Išskirtinės architektūros namas, erdvus ir itin funkcionalus vidaus išplanavimas. Aptvertas 20 a. sklypo teritorija, įvažiavimas pro automatinius vartus.\n  Namas pilnai įrengtas. - Įrengimui naudotos tik kokybiškos apdailos medžiagos: marmuras, ąžuolas.\n- Namas - mūrinis - iš keramikinių plytų, labai ekonomiškas ir šiltas.\n- Puikiai išspręstas vidaus apšvietimas su reguliuojamu šviesos intensyvumu.\n- Įrengta vėdinimo sistema.",
                "currency_symbol": "€",
                "full_name": "Vardenis pavardenis",
                "occupation": "LNTAA sertifikuotas NT ekspertas",
                "company": "Wide Arms Realty",
                "contact_email": "vardenis.pavardenis@gmail.com",
                "mobile_phone_number": "+3706 7949 725",
                "website": "https://usepillar.com",
                "about": "12 metų patirtis pardavinėjant prabangų nekilnojamą turtą Vilniuje. Patikėkite savo brangiausią turtą man. Pažadu nei sekundei neasuabejosite dėl šio sprendimo!",
                "facebook": "https://usepillar.com",
                "twitter": "https://usepillar.com",
                "linkedin": "https://usepillar.com",
                "instagram": "https://usepillar.com",
                "city": "NY",
                "state": "",
                "street": "Nugalėtojų 26",
                "postcode": "postcode",
                "property_details": "Ankstyvą rytą, glostydami pušų viršūnes, į kambarį įsiveržia saulės spinduliai, pro pravertą langą plūsteli grynas oras, o vos tik išriedėjus iš kiemo - belieka 10 minučių iki sekmadieninio pasivaikščiojimo po Vilniaus Senamiestį. Tai ne pasaka apie tobulus namus. Tai - gyvenimas arčiau gamtos. \n  ~470 m iki viešojo transporto stotelės \n  ~540 m iki artimiausios parduotuvės \n  ~800 m iki „Vilties“ klinikos \n  ~710 m iki vaikų lopšelio-darželio „Abadelė“ \n  ~7 km iki Katedros aikštės",
                "close": "Uždaryti",
                "plans": "Planai"
            },
            "general": {
                "overview": "Apie",
                "amenities": "Ypatybės",
                "amenities_you_will_enjoy": "Privalumai, kuriais mėgausitės",
                "photos": "Nuotraukos",
                "view_all_photos": "[2,9] Žiūreti visas {count} nuotraukas|[10,20] Žiūreti visas {count} nuotraukų|[21,29] Žiūreti visas {count} nuotraukas",
                "floor_plans": "Planai",
                "map": "Žemėlapis",
                "contact": "Kontaktai",
                "agent": "Pristato",
                "inquire": "Teirautis",
                "beds": "kambarys|kambariai",
                "baths": "vonia|vonios",
                "bedrooms": "Kambarys|Kambariai",
                "bathrooms": "Vonia|Vonios",
                "Sq. Ft.": "m2",
                "tour_this_house": "Galerija",
                "tour_the_house": "Galerija",
                "view_all": "Žiūrėti visas",
                "view_photos": "Nuotraukas",
                "location": "Lokacija",
                "open_maps": "Atidaryti žemėlapius",
                "presented_by": "Atstovas",
                "get_in_touch": "Susisiekite",
                "first_name": "Vardas",
                "last_name": "Pavardė",
                "email_address": "El. paštas",
                "email": "El. paštas",
                "phone": "Telefono numeris",
                "phone_number": "Telefono numeris",
                "your_message": "Jūsų žinutė",
                "message": "Žinutė",
                "send_message": "Siųsti žinutę",
                "send_inquiry": "Siųsti žinutę",
                "send": "Siųsti",
                "powered_by": "Sukurta naudojant",
                "share_this_property": "Pasidalinkite šia svetaine",
                "close": "Uždaryti",
                "view_our_gallery": "Galerija",
                "location_in_town": "Lokacija",
                "any_questions": "Turite klausimų?",
                "reach_out_to_us": "Susisiekite su mumis",
                "type_here": "Rašykite čia ...",
                "view_photo": "Peržiūrėti nuotrauką",
                "address": "Addresas",
                "price_from": "Kaina nuo",
                "area": "Plotas",
                "explore": "Apsižvalgyk",
                "thank_you_for_your_interest": "Ačiū už susidomėjimą",
                "we_will_contact_you": "Mes su jumis susisieksime kaip galima greičiau",
                "scroll": "Scroll",
                "gallery": "Galerija",
                "location_overflow": "Lokacija",
                "presented_by_overflow": "Parduoda",
                "video_tour": "Video",
                "video": "Video",
                "virtual_tour": "Virtualus turas",
                "more": "Daugiau",
                "listed_by": "Pristato",
                "or": "ar",
                "showing": "Apžiūra",
                "book_a_showing": "Tartis apžiūrai",
                "just_listed": "NAUJAS OBJEKTAS",
                "price_reduced": "SUMAŽINTA KAINA",
                "pending": "REZERVUOTAS",
                "sold": "PARDUOTAS",
                "active": "AKTYVUS",
                "more_information": "Daugiau informacijos",
                "take_a_tour": "Suderinti apžiūrą",
                "more_listings": "More listings"
            }
        },
        "free_trial": {
            "your_free_trial_ends_in": "Jūsų nemokamas planas baigsis už",
            "days": "{count} dienos|{count} dienų",
            "upgrade": "Pratęsti"
        },
        "subdomain_selected": {
            "subdomain_selected": "Subdomenas pasirinktas",
            "congratulations": "Sveikiname! Jūsų svetainė bus matoma adresu",
            "congratulations_description": "Paviešinkite svetainę dabar arba grįžkite į svetainės kūrimą",
            "publish_website": "Paviešinti svetainę",
            "back_to_editing": "Grįžti į kūrimą"
        },
        "common": {
            "back": "Atgal",
            "continue": "Tęsti",
            "next": "Toliau",
            "max_file_size": "Maksimalus dydis: 20Mb",
            "preview": "Peržiūrėti",
            "file_size_too_big": "Failas per didelis. Maksimalys failo dydis: 20Mb",
            "close": "Uždaryti",
            "cancel": "Atšaukti",
            "select": "Pasirinkti",
            "crop_and_resize": "Apkirpti",
            "change_photo": "Pakeisti nuotrauką",
            "remove_photo": "Ištrinti nuotrauką",
            "are_you_sure": "Ar tikrai norite ištrinti šią nuotrauką?",
            "remove": "Ištrinti",
            "terms_of_service": "Sąlygomis ir nuostatomis",
            "terms_of_service_nominative": "Sąlygos ir nuostatos",
            "privacy_policy": "Privatumo politika",
            "and": "ir",
            "all_rights_reserved": "© Pillar Technologies LTD 2020. Visos teisės saugomos.",
            "currency_sign": "€",
            "dashboard": "Pagrindinis",
            "desktop": "Kompiuteris",
            "tablet": "Planšetė",
            "mobile": "Telefonas",
            "view_demo": "Peržiūrėti",
            "select_template": "Paleisti svetainę",
            "save": "Išsaugoti",
            "add_video": "Add video",
            "replace_video": "Replace video",
            "select_photo": "Select photo",
            "blog": "Dienoraštis",
            "limit_reached_upgrade_plan": "Pasiektas aktyvių sąrašų limitas – atnaujinkite planą"
        },
        "card_details": {
            "card_number": "Kortelės numeris",
            "name_on_card": "Pilnas vardas ant kortelės",
            "name_on_card_placeholder": "John Doe",
            "expiration": "Galioja iki",
            "order_summary": "Krepšelis",
            "domain_for_listing_site": "adresas objekto svetainei",
            "one_time_payment": "Vienkartinis mokėjimas",
            "no_hidden_fees": "Jokių papildomų mokesčių, jokios prenumeratos",
            "valid_for_one_year": "Galioja vieneriems metams",
            "pay": "Mokėti",
            "card_number_required": "Reikalingas kortelės numeris",
            "month_required": "Reikalingas kortelės galiojimo laikas",
            "cvc_required": "Reikalingas kortelės CVC kodas",
            "name_is_required": "Reikalingi vardas pavardė"
        },
        "account": {
            "account_settings": "Nustatymai",
            "profile": "Profilis",
            "password": "Slaptažodis",
            "billing": "Apmokėjimai",
            "first_name": "Vardas",
            "first_name_placeholder": "Įveskite vardą",
            "last_name": "Pavardė",
            "last_name_placeholder": "Įveskite pavardę",
            "work_email_address": "El. paštas",
            "work_email_address_placeholder": "Įveskite el. paštą",
            "old_password": "Senas slaptažodis",
            "password_placeholder": "Įveskite slaptažodį",
            "new_password": "Naujas slaptažodis",
            "confirm_new_password": "Patvirtinkite naują slaptažodį",
            "change_password": "Pakeisti slaptažodį",
            "update_settings": "Atnaujinti",
            "active_listings": "{0} Nėra aktyvių svetaionių|[1] {count} aktyvi svetainė|[2,*] {count} aktyvios svetainės",
            "your_plan": "Jūsų planas",
            "upgrade": "Pagerinti",
            "cancel_plan": "Atšaukti planą",
            "change_card": "Pakeisti duomenis",
            "payment_method": "Kortelės duomenys",
            "update_card": "Atnaujinti",
            "cancelled": "Atšauktas",
            "active_until": "aktyvus iki",
            "renew": "Atnaujinti",
            "we_will_send_you_text_notifications": "We will send you text notifications when you receive a new lead on one of your property websites",
            "phone_number": "Phone number for SMS notifications"
        },
        "analytics": {
            "yesterday": "Yesterday",
            "last_week": "Last week",
            "last_month": "Last month",
            "last_7_days": "Last 7 days",
            "last_30_days": "Last 30 days",
            "all_time": "All time"
        },
        "plan_ended": {
            "please_reactivate_your_plan": "Atnaujinkite planą",
            "free_trial_has_ended": "Bandymas baigėsi",
            "your": "Jūsų",
            "subscription_has_ended": "planas pasibaigė",
            "days_free_trial_has_ended": "dienų bandymas baigėsi",
            "description": "Mes tikimės, kad jums Pillar buvo naudingas. Prašome atnaujinti planą arba pasirinkti kitą, kad galėtumėte toliau naudotis mūsų paslaugomis.",
            "description2": "Susisiekite su mumis jeigu turite klausimų.",
            "see_plans": "Peržiūrėti planus",
            "contact_support": "Susisiekti"
        },
        "early_preview": {
            "finish_setting_up_title": "Užbaikite puslapio kūrimą per kelias minutes",
            "finish_setting_up_description": "Užpildykite likusią informaciją ir išsirinkite tinkamą domeną",
            "continue_editing": "Tęsti redagavimą"
        },
        "getting_started": {
            "template": "Šablonas",
            "customization": "Pritaikymas",
            "preview_and_next_steps": "Peržiūra ir kiti žingsniai",
            "preview": "Peržiūrėti",
            "customize_your_website": "Pritaikykite savo puslapį",
            "customize_your_website_description": "Pridėkite savo objekto adresą ir nuotraukas. Nesijaudinkite - vėliau galėsite pridėti daugiau informacijos.",
            "add_property_address": "Pridėkite objekto adresą",
            "add_property_photos": "Pridėkite objekto nuotraukas",
            "i_dont_have_any_photos_with_me": "Aš neturiu nuotraukų su savimi",
            "upload_up_to_20_photos": "Įkelkite iki 20 nuotraukų",
            "view_your_website": "Peržiūrėti puslapį",
            "or_skip_this_step": "Praleisti žingsnį",
            "sign_up_to_view_your_website": "Susikurkite pirmą objekto puslapį",
            "first_name": "Vardas",
            "first_name_placeholder": "Vardenis",
            "last_name": "Pavardė",
            "last_name_placeholder": "Pavardenis",
            "email_address": "El. Pašto adresas",
            "email_address_placeholder": "vardenis@kompanija.lt",
            "phone_number": "Tel. numeris",
            "phone_number_placeholder": "+370 6000 0000",
            "create_password": "Slaptažodis",
            "create_password_placeholder": "8+ raidės",
            "finish_setting_up_your_account": "Užsiregistruokite peržiūrėti savo puslapį",
            "and": "ir",
            "by_signing_up_you_agree_to_pillars": "Registruodamiesi jūs sutinkate su",
            "not_subscribe_text": "Nenoriu gauti informacijos apie produkto atnaujinimus ir naujienas.",
            "continue": "Toliau",
            "sign_up": "Registruotis",
            "uploading": "Įkeliama...",
            "compressing_photo": "Optimizuojama nuotrauka",
            "unable_to_upload": "Nepavyko įkelti, pabandykite vėliau.",
            "14_day_free_trial": "7 day free trial",
            "no_card_required": "No card required",
            "cancel_anytime": "Cancel anytime"
        },
        "components": {
            "schedule_showing": {
                "monday": "Pirmadienis",
                "tuesday": "Antradienis",
                "wednesday": "Trečiadienis",
                "thursday": "Ketvirtadienis",
                "friday": "Penktadienis",
                "saturday": "Šeštadienis",
                "sunday": "Sekmadienis",
                "title": "Susitarkite apžiūros laiką"
            },
            "video_tour": {
                "upload_video": "Įkelkite objekto video tiesiai iš YouTube ar Vimeo",
                "embed_video": "Įkelti YouTube ar Vimeo video",
                "video_tour": "Video ir virtualus turas",
                "hd_quality": "HD kokybė"
            },
            "embed_virtual_tour": {
                "embed_virtual_tour": "Įkelti Matterport turą",
                "add_video_link": "Virtualaus turo adresas",
                "video_embedded": "Video įkeltas",
                "failed_to_embed_video": "Nepavyko įkelti video",
                "embed_video": "Įkelti Matterport turą"
            },
            "templates": {
                "lock_listing": {
                    "title": "Tęskite šio objekto apžiūrą",
                    "full_name": "Vardas",
                    "email_address": "El. pašto adresas",
                    "phone_number": "Telefono numeris",
                    "tour_this_home": "Tęsti apžiūrą"
                },
                "exit_intent": {
                    "title": "Prieš išeinant...",
                    "description": "Būkite pirmas kuriam pranešime apie išskirtinius pasiūlymus jūsų vietovėje!",
                    "full_name": "Vardas pavardė",
                    "email_address": "El. pašto adresas",
                    "phone_number": "Telefono numeris",
                    "get_offers": "Gauti pasiūlymus",
                    "no_thanks": "Ne, ačiū",
                    "request_received": "Užklausa gauta",
                    "we_will_send": "Mes greitu metu su jumis susisieksime",
                    "close": "Uždaryti"
                },
                "book_a_showing": {
                    "book_a_showing": "Tartis apžiūrai",
                    "appointment_type": "Apžiūros tipas",
                    "in_person": "Gyva apžiūra",
                    "virtual_showing": "Apžiūra telefonu",
                    "appointment_date": "Apžiūros data",
                    "preferred_time": "Tinkamiausias laikas",
                    "morning": "Rytas",
                    "afternoon": "Vidurdienis",
                    "evening": "Vakaras",
                    "full_name": "Pilnas vardas",
                    "john_doe": "John Doe",
                    "email_address": "El. paštas",
                    "johndoe_realestate_com": "Johndoe@realestate.com",
                    "phone_number": "Telefono nr.",
                    "phone_number_placeholder": "+3706 0000000",
                    "additional_information": "Papildoma informacija",
                    "i_would_like_to_shedule_a_showing": "Aš norėčiau užsiregistruoti apžiūrai",
                    "confirm_booking": "Patvirtinti apžiūrą",
                    "tour_confirmed_for": "patvirtinta. Data: ",
                    "thanks_for_booking": "Ačiū, apžiūros laikas patvirtintas."
                }
            },
            "embed_video": {
                "add_video_link": "Pridėti video nuorodą",
                "embed_video": "Įkelti YouTube ar Vimeo video",
                "video_embedded": "Video Įkeltas",
                "failed_to_embed_video": "Nepavyko įkelti video",
                "edit_embed_video": "Edit YouTube or Vimeo video cover",
                "edit_video_link": "Edit video link",
                "as_top_section_cover": "Add this video as top section cover"
            },
            "additional_documents": {
                "additional_documents": "Papildomi dokumentai",
                "upload_a_file": "Įkelti failą",
                "or": "arba",
                "insert_a_link": "Pridėti nuorodą",
                "added_documents": "Pridėti dokumentai",
                "edit_link": "Pakeisti nuorodą",
                "remove": "Pašalinti",
                "cancel": "Atšaukti",
                "link_url": "Adresas",
                "link_text": "Pavadinimas",
                "insert_link": "Pridėti",
                "edit": "Redaguoti",
                "link_text_placeholder": "Nuorodos pavadinimas",
                "link_url_placeholder": "https://drive.google.com/link",
                "update_a_link": "Atnaujinti nuorodą",
                "update": "Atnaujinti",
                "delete_file_title": "Pašalinti failą",
                "delete_link_title": "Pašalinti nuorodą",
                "delete_file_description": "Ar tikrai norite pašalinti šį failą?",
                "delete_link_description": "Ar tikrai norite pašalinti šią nuorodą?",
                "change_file_title": "Pakeisti failo pavadinimą",
                "file_title": "Failo pavadinimas"
            }
        },
        "landing_page": {
            "main": {
                "product": "Produktas",
                "pricing": "Planai",
                "designs": "Dizainai",
                "contact_us": "Susisiekite",
                "login": "Prisijungti",
                "hero_title": "Susikurkite stulbinantį puslapį jūsų objektui tik per 7 minutes!",
                "hero_description": "Pateikite savo parduodamus objektus dar profesionaliau! Išsiskirkite iš minios, parduokite greičiau bei gaukite dar daugiau objektų!",
                "get_started_for_free": "Pradėkite nemokamai",
                "agents_helped": "Agentų padėta",
                "websites_created": "Sukurta svetainių",
                "plans_and_visuals_made": "Planų ir vaizdinių sukurta",
                "stand_out_from_the_croud": "Išsiskirk iš minios",
                "make_your_listings_stnd_out": "Išsiskirk iš minios su prisitaikančiomis skelbimo svetainėmis, kurios pabrėžia geriausias objekto dalis, parodo jūsų patirtį rinkoje ir pritraukia potencialių pirkėjų.",
                "faster": "Greitai",
                "faster_description": "tereikia tik 7 minučių,kad jūs sukurtumėte pirmąją interneto svetainę savo skelbimui.",
                "cheaper": "Pigiai",
                "cheaper_description": "Kainuoja tik nuo 14 Eur per mėnesį: unikali svetainė kuri yra du kartus pigesnė nei skelbimas NT portale",
                "beautiful": "Išskirtinai",
                "beautiful_description": "Visada atnaujinami aukščiausios klasės dizainai sukurti pritraukti dėmesį pritraukti naujų potencialių pirkėjų",
                "as_easy": "Taip pat paprasta kaip sukurti skelbimą NT portale",
                "choose_a_template": "Pasirinkite šabloną",
                "choose_a_template_description": "Pasirinkite vieną iš mūsų dizainerių kurtų nekilnojamo turto objekto puslapio šablonų",
                "add_listing_information": "Pridėkite skelbimo informaciją",
                "add_listing_information_description": "Įveskite objekto informaciją. Aprašymas, nuotraukos, vieta t.t.",
                "pick_a_domain": "Pasirinkite domeną",
                "pick_a_domain_description": "Sudėjus visą informaciją, paprasčiausiai paspauskite “Skelbti” arba pasirinkite bet kokį domeną savo internetiniam puslapiui. Jūsų skelbimas jau paruoštas per 7minutes!",
                "join_hundreds": "Pateikite savo objektus dar patraukliau! Prisijunkite prie Pillar!",
                "pillar_helps": "Padėsime Jums savo pardavimus kilstelėti dar vienu laipteliu aukštyn!",
                "request_demo": "Konsultacija",
                "what_our_customers_are_saying": "Ką sako mūsų klientai",
                "supercharge_your_listing": "Ar pasiruošę pagerinti savo skelbimus?",
                "supercharge_your_listing_description": "Praleiskite mažiau laiko prie stalo ir daugiau laiko plėsdami savo verslą.",
                "spend_more_time_building": "Praleiskite mažiau laiko prie stalo",
                "your_business": "ir daugiau laiko plėsdami savo verslą.",
                "get_started_now": "Pradėkite jau dabar",
                "full_name": "Pilnas vardas",
                "email_address": "El. Paštas",
                "company": "Įmonė (nebūtina)",
                "your_message": "Jūsų žinutė",
                "send_message": "SIŲSTI ŽINUTĘ",
                "arrange_for_consultation": "Susitarti konsultacijai",
                "first_name": "Vardas",
                "last_name": "Pavardė",
                "job_title": "Pareigos",
                "company_name": "Įmonė",
                "phone_number": "Tel. Numeris",
                "your_message_optional": "Jūsų žinutė (nebūtina)",
                "thoughtfully_crafted_designs": "Kruopščiai sukurti dizainai",
                "our_designs": "Mūsų šablonai yra specifiškai sukurti tam, kad jūsų objektai atrodytų išskirtinai ir pritrauktų daugiau potencialių pirkėjų dėmesio",
                "view_designs": "Peržiūrėti dizainus",
                "view": "Peržiūrėti",
                "get_started": "Pradėkite",
                "book_a_demo": "Konsultacija",
                "free_trial_no_cc_required": "Free trial. No Credit card required",
                "see_how_it_works": "Žiūrėti pristatymą",
                "watch_our_demo": "Peržiūrėkite mūsų 2min demo",
                "dont_believe_how_easy_it_is": "Netikite, kad viskas taip paprasta? Peržiūrėkite mūsų trumpą apžvalgą rodančią, kaip sukurti puslapį jūsų objektui per kelias minutes.",
                "as_seen_on": "As seen on",
                "trusted_by": "Trusted by",
                "review_1": "“It's so easy. I received a couple of new properties because I quickly built websites for them. The design is great and looks professional.”",
                "review_2": "“The most beautiful, versatile and fastest website builder for real estate I’ve ever seen. As easy as a breeze to work with, highly recommended for everyone without missing a classy touch and saving hundreds (if not thousands).”",
                "review_3": "“Pillar has set the trend for efficiently creating stylish websites that could’ve been made only by a professional web design agency. The quality of templates is where Pillar outshines its competition.”",
                "review_4": "“I quickly made a website on the platform to attract the owner’s attention and get the listing! Just heard from him that the house is mine to sell - exclusively. Cheers guys!”",
                "review_5": "“I shared my new listing site with my network and client database three days ago. As of today I had 5 potential buyers request information about the property and I already arranged a viewing with 3 of them.”"
            },
            "components": {
                "exit_intent_popup": {
                    "enter_your_email": "Enter your email and get 10% off any plan!",
                    "email_address": "Email address",
                    "yes_i_want_discount": "Yes! I want 10% Off",
                    "no_thanks": "No thanks",
                    "discount_applied": "We have applied the discount to your email - now finish signing up to use it!",
                    "finish_signing_up": "Finish signing up"
                }
            },
            "get_started": {
                "select_a_template": "Pasirinkite šabloną",
                "select_a_template_description": "Pasirinkite vieną iš šablonų. Kiekvienas šablonas sukurtas skirtingo stiliaus objektams. Nesijaudinkite - jūs taip pat galėsite pasikeisti šabloną vėliau."
            },
            "pricing": {
                "hero_title": "Visiems prieinama kaina",
                "hero_description_1": "Neprašome kredinės kortelės duomenų pabandymui.",
                "hero_description_2": "24/7 klientų aptarnavimas įskaičiuotas į visus planus. Pakeisk arba atšauk savo planą bet kada.",
                "additional_services": "Papildomos paslaugos",
                "3d_plans": "3D planai",
                "3d_plans_description": "pagal užsakymą sukurtas 3D planas jūsų objektui remiantis jūsų objekto statybos planu ir reikalavimais per tris  darbo dienas. Susisiekite su mumis dėl daugiau informacijos.",
                "plan": "planą",
                "visual": "vizualizaciją",
                "visualizations": "Vizualizacijos",
                "visualizations_description": "Gaukite aukščiausios kokybės vizualizaciją per tris  darbo dienas. Susisiekite su mumis dėl daugiau informacijos",
                "faq_question_1": "Ar yra nemokama versija?",
                "faq_answer_1": "Taip, yra 14 dienų nemokama versija, kurioje galite padaryti 5 internetines svetaines jūsų parduodamiems objektams. Nemokamoje versijoje galėsite naudotis visomis papildomomis funkcijomis.",
                "faq_question_2": "Kiek kainuoja objekto internetinė svetainė?",
                "faq_answer_2": "Internetinė svetainė objektui kainuoja 13 eurų per mėnesį už atskirą internetinį puslapį. Pasirinktą planą galima bet kada padidinti, pamažinti arba nutraukti. ",
                "faq_question_3": "Kiek kainuoja unikalus domenas?",
                "faq_answer_3": "Unikalus domenas kainuoja 14 eur. - pirkti jį galite tiesiogiai iš mūsų pillar svetainės.",
                "faq_question_4": "Ką daryti jei pasiekiu įkeliamų objektų limitą?",
                "faq_answer_4": "Jei pasiekiate limitą bet kada galite palite padidinti planą su didesniu objektų limitu.",
                "faq_question_5": "Kodėl turėčiau rinktis metinį planą?",
                "faq_answer_5": "Tai puiki galimybė gauti dar geresnį pasiūlymą! Renkantis metinį planą mes siūlome 15% nuolaidą.",
                "faq_question_6": "Ar galiu įkelti PDF dokumentus ( tokius kaip namo planas, preliminari sutartis ir t.t.) į savo internetinį objekto puslapį?",
                "faq_answer_6": "Taip, dokumentų įkėlimas į internetinį puslapį yra galimas.",
                "faq_question_7": "Ar galiu įkelti virtualų turą į internetinį objekto puslapį?",
                "faq_answer_7": "Taip, būsite nustebinti kaip paprasta tai padaryti.",
                "faq_question_8": "Ar pardavus objektą galiu ištrinti internetinį puslapį taip padarant vietos naujam papildomam objektui?",
                "faq_answer_8": "Taip, ištrynę nebenaudojamą internetinį puslapį padarysite papildomos vietos naujam. Galėsite talpinti tiek puslapių kiek jums tai leis daryti jūsų pasirinktas planas.",
                "whats_included": "Viskas ko reikia",
                "coming_soon": "Netrukus",
                "faq": "Dažnai užduodami klausimai",
                "mobile_first": "Mobile first",
                "free_subdomain": "Free subdomain",
                "free_hosting": "Free hosting",
                "messenger_live_chat": "Messenger live chat",
                "buy_a_unique_domain": "Buy a unique domain",
                "upload_docs_and_links": "Upload docs & links",
                "integrate_virtual_tour": "Integrate virtual tour",
                "upload_videos_and_floor_plans": "Upload videos & floor plans",
                "free_ssl_certificates": "Free SSL certificates",
                "google_maps": "Google maps",
                "facebook_pixel": "Facebook Pixel",
                "share_to_social_media": "Share to social media",
                "schedule_a_showing": "Schedule a showing",
                "seo_optimized": "SEO Optimized",
                "mls_unbranded_version": "MLS unbranded version",
                "leave_intent_capture": "Leave intent capture",
                "set_as_just_listed": "Set as just listed, price reduced, pending, sold",
                "unlock_listing_capture": "“Unlock listing” capture",
                "add_open_house_times": "Add open house times",
                "coming_soon_lead_capture": "“Coming soon” lead capture",
                "listing_website_analytics": "Listing website analytics"
            },
            "designs": {
                "hero_title": "Puslapių dizainai padedantys išsiskirti iš minios",
                "hero_description": "Mūsų šablonai yra specifiškai sukurti tam, kad jūsų objektai atrodytų išskirtinai ir pritrauktų daugiau potencialių pirkėjų dėmesio"
            }
        },
        "pricing": {
            "choose_a_plan": "Pasirinkite planą",
            "choose_a_plan_description": "24/7 klientų aptarnavimas įskaičiuotas į visus planus. Pakeisk arba atšauk savo planą bet kada.",
            "monthly": "Kas mėnesį",
            "yearly": "Kas metus",
            "save_15_percent": "Sutaupykite 15%",
            "starter": "Starter",
            "advanced": "Advanced",
            "professional": "Professional",
            "professional_30": "Professional 30",
            "professional_60": "Professional 60",
            "professional_120": "Professional 120",
            "enterprise": "Enterprise",
            "mo": "mėn",
            "starter_description": "Sukurk vieną svetainę - tinkamiausias vartotojams išbandantiems mūsų platformą.",
            "advanced_description": "Turėkite iki 5 aktyvių svetainių vienu metu – geriausia pasirinktiems projektams",
            "professional_description": "Turėkite iki 15 aktyvių svetainių vienu metu - tinkamiausias agentams su didensiu objektų kiekiu",
            "professional_30_description": "Upgrade your professional plan to create up to 30 listing sites",
            "professional_60_description": "Upgrade your professional plan to create up to 60 listing sites",
            "professional_120_description": "Upgrade your professional plan to create up to 120 listing sites",
            "enterprise_description": "Daugiau funkcionalumo verslui, įmonės identiteto pridėjimas ir daugiau",
            "enterprise_feature_1": "Neribotas skelbimų skaičius",
            "enterprise_feature_2": "Pažangesnė apsaugos sistema",
            "enterprise_feature_3": "Agentų darbo srauto kontroliavimas",
            "select": "Pradėti",
            "current_plan": "Esamas planas",
            "plan": "planas",
            "billed": "Apmokama",
            "total_billed": "Sumokama dabar",
            "upgrade_my_plan": "Pirkti planą",
            "contact_us": "Susisiekti",
            "order_summary": "Krepšelis",
            "renew_successful": "Atnaujinimas sėkmingas",
            "back_to_dashboard": "Grįžti į pradinį",
            "add_another_listing": "Sukurti naują svetainę",
            "lets_finish_upgrading": "Pabaikime gerinti jūsų planą",
            "plan_is_right_for_you": "planas yra tinkamiausias jums",
            "upgrade_successful": "Atnaujinimas sėkmingas",
            "starter_monthly_price": "11",
            "starter_yearly_price": "9",
            "advanced_monthly_price": "39",
            "advanced_yearly_price": "34",
            "professional_monthly_price": "79",
            "professional_yearly_price": "67",
            "3d_plan_price": "89",
            "visual_price": "358",
            "other_plans": "Kiti planai",
            "whats_included": "Viskas ko reikia",
            "coming_soon": "Netrukus",
            "faq": "Dažnai užduodami klausimai",
            "advanced_monthly_per_site": "7.8",
            "advanced_yearly_per_site": "6.8",
            "professional_monthly_per_site": "5.26",
            "professional_yearly_per_site": "4.46",
            "professional_30_monthly_per_site": "3.1",
            "professional_30_yearly_per_site": "2.7",
            "professional_60_monthly_per_site": "2.7",
            "professional_60_yearly_per_site": "2.3",
            "professional_120_monthly_per_site": "2.3",
            "professional_120_yearly_per_site": "2",
            "per_site_month": "už puslapį /mėn",
            "per_additional_site_month": "už papildomą puslapį /mėn"
        },
        "listing_published": {
            "listing_published": "Svetainė paviešinta",
            "congratulations": "Sveikiname!",
            "your_listing": "Jūsų objekto svetainė buvo paviešinta. Pasidalinkite ja su kitais naudodamiesi mūsų socialinės medijos nuorodomis",
            "view_live_website": "Peržiūrėti svetainę",
            "dashboard": "Eiti į meniu",
            "copy_link": "Kopijuoti nuorodą"
        }
    },
    "ru": {
        "pagination": {
            "previous": "&laquo; Previous",
            "next": "Next &raquo;"
        },
        "listing": {
            "description": "Особняк на две семьи, отличается от всех остальных в Бруклине. Если вы искали дом, который действительно просторный, светлый, с продуманной планировкой и дизайном, то вы его нашли. 64 Jackson – это совершенно новый дом, построенный по индивидуальному заказу, в котором все продуманно до мельчайших деталей, и выполнено с мастерством. Это не дом, построенный застройщиком для продажи, это искусно созданная резиденция, в которой все аспекты строительства превосходят ожидание. Дом, спроектированный студией Asa Barak Studio, построен из великолепного импортного кирпича Petersen, обработанного водной струей. Этот 25'дом полностью оборудован для того, чтобы с комфортом принять до 150 гостей или для уединенного отдыха в читальном уголке у камина. Планировка гибкая – гостиная площадью более 1085 квадратных футов открытого лофта. Кухня оснащена мобильным островом, бесшовной раковиной из нержавеющей стали и меблирована дубовыми шкафами с однослойной отделкой. Комната позволяет изменять и трансформировать пространство в зависимости от требований к развлечениям. На веранде – открытый газовый камин со стеклянными панелями от пола до потолка и индивидуальной металлической отделкой. Это пространство, которое нужно увидеть, чтобы по-настоящему оценить его достоинства.",
            "about_agent": "Например, Николас имеет более 15 лет опыта работы в сфере коммерческой и жилой недвижимости. Он, пожалуй, является самым влиятельным и ответственным брокером розничного сегмента Hell’s Kitchen, превращая его в оживленный ресторан и торговую площадку с космополитической привлекательностью. Будучи одним из партнеров-основателей известной фирмы по недвижимости Wide Arms Realty, Николас помогает контролировать отношения с несколькими ключевыми владельцами и советами кооперативов.",
            "property_details": "Вы находитесь менее чем в двух кварталах от поезда L и недалеко от поездов J и Z. Позвольте себе расслабиться на открытом воздухе в общественном месте? Прогуляйтесь по парку Ирвинг-сквер и найдите время, чтобы расслабиться, всего в нескольких кварталах от вашего дома. Не стесняйтесь обращаться к нам, чтобы ознакомиться с этим прекрасным таунхаусом."
        },
        "auth": {
            "login": {
                "welcome": "Добро пожаловать",
                "login_to_continue": "Войдите, чтобы продолжить",
                "your_email": "Адрес электронной почты",
                "your_email_placeholder": "johndoe@realestate.com",
                "your_password": "Пароль",
                "your_password_placeholder": "Введите пароль",
                "login": "Вход",
                "dont_have_an_account": "Нет учетной записи?",
                "sign_up_for_free": "Войдите бесплатно",
                "forgot_password": "Забыли пароль?",
                "failed": "Пожалуйста, проверьте данные учетной записи",
                "log_into_pillar": "Войдите в Pillar",
                "or": "или",
                "continue_with_google": "Зайти с Google",
                "continue_with_facebook": "Зайти с Facebook",
                "continue_with_email": "Введите пароль"
            },
            "change_password": {
                "enter_new_password": "Введите новый пароль",
                "new_password": "Новый пароль",
                "password_placeholder": "Введите пароль",
                "confirm_new_password": "Подтвердите новый пароль",
                "set_new_password": "Установите новый пароль",
                "take_me_back_to_login_screen": "Назад на страницу входа в систему"
            },
            "reset_password": {
                "reset_password": "Сброс пароля",
                "reset_password_description": "Мы можем помочь вам сбросить пароль, используя адрес электронной почты, закрепленный за вашей учетной записью.",
                "your_email": "Ваш адрес электронной почты",
                "your_email_placeholder": "johndoe@realestate.com",
                "reset_my_password": "Сбросить пароль",
                "take_me_back_to_login_screen": "Назад на страницу входа в систему"
            }
        },
        "listing_form": {
            "listing_template": {
                "select_a_template": "Выберите шаблон",
                "choose_one": "Выберите один из шаблонов, представленных в нашем списке. Каждый был создан для определенной цели. Не волнуйтесь, если захотите, вы можете изменить шаблон позже.",
                "select": "Выбрать",
                "select_template": "Запустить веб-сайт",
                "preview": "Предварительный просмотр",
                "selected": "Отобрано",
                "baroque": "Барокко",
                "this_sophisticated": "Этот сложный шаблон можно использовать в различных целях, и он лучше всего подходит более классическим объектам.",
                "modernist": "Модерн",
                "minimalist_template": "Минималистичный шаблон помогает сосредоточиться на контенте – лучше всего подходит для более современных объектов недвижимости или объектов с высококачественными фотографиями.",
                "gothic": "Готика",
                "this_unique": "Этот уникальный шаблон поможет вам выделить желаемый объект еще больше благодаря темному дизайну. Подходит для различных объектов.",
                "byzantine": "Византия",
                "cozy_and": "Уютный и приветливый всегда побеждает. Этот легкий и игривый дизайн поможет вашей недвижимости выглядеть еще более уютной.",
                "art_deco": "Арт-деко",
                "thanks_to": "Благодаря голубым акцентам этот шаблон больше всего подходит для объектов недвижимости, которые должны вызывать доверие. Идеально подходит для корпоративной или минималистской недвижимости.",
                "most_popular": "Самое популярное",
                "victorian": "Викторианский",
                "our_most": "Наш самый универсальный шаблон, который подходит для любого типа недвижимости. Позвольте вашему объявлению выглядеть более элегантным с помощью акцентов темно-зеленого цвета."
            },
            "listing_photos": {
                "review_and_add_more_photos": "Просмотрите и добавьте больше фотографий",
                "upload_photos_description": "Загрузите фотографии объекта, который хотите опубликовать. Измените порядок фотографий, размещая их в выбранном вами порядке, меняя местоположение фотографий при помощи мышки",
                "upload_photos": "Загрузить фотографии",
                "upload_more_photos": "Загрузить больше фотографий"
            },
            "help_popup": {
                "information_about_the_location": "Информация о местонахождении",
                "information_about_the_location_description": "Вы находитесь менее чем в двух кварталах от поезда L и недалеко от поездов J и Z. Позвольте себе расслабиться на открытом воздухе в общественном месте? Прогуляйтесь по парку Ирвинг-сквер и найдите время, чтобы расслабиться, всего в нескольких кварталах от вашего дома. Не стесняйтесь обращаться к нам, чтобы ознакомиться с этим прекрасным таунхаусом.",
                "top_section_title": "Заголовок верхнего раздела",
                "top_section_description": "Это первая часть информации, которую видят посетители, открывая вашу веб-страницу. Рекомендуем короткие и запоминающиеся фразы.",
                "top_section_square_footage": "Верхняя часть – Площадь в футах и цена",
                "top_section_square_footage_description": "Пожалуйста, введите количество квадратных футов и цену для вашего объявления.",
                "top_section_beds_and_baths": "Верхняя часть - Кровати и ванные",
                "top_section_beds_and_baths_description": "Укажите количество спален и ванных комнат в вашем объявлении.",
                "top_section_hero_image": "Фото верхнего раздела (или добавьте видео)",
                "top_section_hero_image_description": "Добавьте фото или видео объекта, который будет отображаться вверху страницы. У вас есть видео? Наведите указатель мышки и нажмите «Добавить видео», чтобы добавить видео из YouTube или Vimeo.",
                "top_section_logo": "Верхняя часть - Логотип",
                "top_section_logo_description": "Чтобы создать индивидуальный фирменный стиль, загрузите свой личный логотип или логотип компании.",
                "overview_title_and_text": "Обзор – заголовок и текст обзора",
                "overview_title_and_text_description": "Здесь вы можете добавить более подробное описание недвижимости, которую вы продаете. Добавьте собственный заголовок, чтобы сделать объявление еще более уникальным",
                "overview_images": "Обзор – обзорные фотографии",
                "overview_images_description": "Вам предоставляется возможность загрузить две фотографии объекта, которые выделяются на фоне остальных, чтобы сделать его более привлекательным.",
                "amenities": "Удобства",
                "amenities_description": "Чтобы привлечь посетителей, укажите особенности объекта. Просто введите слово и нажмите Enter. Чтобы удалить функцию, щелкните значок «X» рядом с выбранной функцией.",
                "listing_photos": "Размещение фотографий",
                "listing_photos_description": "В данном разделе вы показываете все фотографии недвижимости. Для большей наглядности вы также можете сгруппировать фотографии в разделы.",
                "floor_plans": "Планировка этажей",
                "floor_plans_description": "Планы этажей, особенно трехмерные, могут помочь лучше понять недвижимость и ее планировку, что увеличивает количество просмотров. Если у вас есть только простой план этажа и вы хотите преобразовать его в индивидуальный трехмерный план, свяжитесь с нами, и мы будем рады помочь.",
                "share_a_bit_about_yourself": "Расскажи немного о себе",
                "share_a_bit_about_yourself_description": "Расскажи посетителям вашего сайта немного о себе – пара предложений о себе и своем опыте.",
                "add_your_social_media_links": "Добавьте ссылки на социальные сети",
                "add_your_social_media_links_description": "Позвольте посетителям веб-страниц найти вас в социальных сетях. Просто скопируйте ссылки на ваши профили в социальных сетях. Вы можете скопировать ссылки из браузера, открыв каждый из своих социальных профилей.",
                "video_tour": "Загрузить видео или виртуальный тур",
                "video_tour_description": "Загрузите видео об объекте и/или виртуальный тур, и мы покажем их между разделами «Удобства» и «Фотогалерея».",
                "listing_agent_title": "Добавить агента по объявлениям",
                "listing_agent_description": "Если не вы отвечаете за размещение информации о недвижимости, и хотите, чтобы на веб-странице был упомянут агент, мы рекомендуем добавить его контактную информацию здесь.",
                "co_agent_title": "Добавить сопредставителя",
                "co_agent_description": "Указали ли вы данную недвижимость вместе с другим агентом? Добавьте информацию об агенте ниже, и агент будет отображаться у вас в разделе «Агент».",
                "schedule_showing": "Разрешите посетителям забронировать тур",
                "schedule_showing_description": "Привлекайте больше посетителей, позволяя им запланировать личный тур или виртуальный показ прямо посредством веб-страницы. Просто установите часы, когда посетители смогут запланировать показы, и мы сообщим вам об этом по электронной почте.",
                "messenger": "Чат в мессенджере",
                "messenger_description": "Превратите посетителей веб-страницы в потенциальных клиентов с помощью инструмента чата Facebook Messenger, встроенного прямо в вашу веб-страницу. Чтобы общаться с посетителями напрямую посредством приложения Messenger без необходимости загружать какие-либо дополнительные приложения, вам необходимо быть администратором бизнес-страницы Facebook.",
                "additional_documents": "Добавьте дополнительные документы",
                "additional_documents_description": "Добавьте документы (например, информацию ограниченного доступа или информацию о продавце) к своему объявлению, чтобы посетители могли видеть все подробности об объекте в едином месте. Также можно добавить ссылки на внешние веб-страницы, указывающие на дополнительную информацию. <br> Совместимый тип файлов: PDF, DOC, XLS, CSV, ODT, TXT.",
                "as_top_section_cover_title": "Добавьте видео в качестве обложки верхнего раздела",
                "as_top_section_cover_description": "Вы также можете вместо фотографии разместить видео в верхней части веб-страницы – это будет первое, что увидят посетители.",
                "exit_intent_popup": "Всплывающее окно с намерением выхода",
                "exit_intent_popup_description": "Привлекайте больше потенциальных клиентов с помощью всплывающего окна, созданного для посетителей, покидающих ваш сайт. Во всплывающем окне посетителей просят оставить свои контактные данные с целью получать эксклюзивные предложения в их районе. Таким образом, вы можете связаться с потенциальными клиентами и предложить им другую недвижимость, которая может их заинтересовать.",
                "lock_listing": "Просмотр списка только после регистрации",
                "lock_listing_description": "Если у вас есть новая или недвижимость на продажу, или вскоре таковая появится, и вы хотите привлечь потенциальных клиентов, позвольте посетителям разблокировать объявление после того, как они зайдут на страницу зарегистрировавшись посредством электронной почты. Пожалуйста, не забудьте, что список не будет доступен без регистрации.",
                "listing_status": "Статус объявления",
                "listing_status_description": "Измените статус объявления на «Только что добавлен в список», «Активно», «Цена снижена\", «В ожидании» или «Продано», чтобы посетители знали, в каком состоянии находится объект. Обновляя свой статус в списке, вы можете отправлять сообщения своим контактам и обновлять социальные сети, чтобы привлечь больше внимания и привлечь потенциальных клиентов.",
                "display_more_listings": "Display more listings",
                "display_more_listings_description": "Let your website visitors discover other listings you have on Pillar by showcasing them at the bottom of the website. Other listings you have on Pillar will be shown in the “More listings” section.",
                "change_colors": "Change template colors",
                "change_colors_description": "Change the colors of the selected template to make your property website even more unique. Choose from recommended colors, which are compatible with both light and dark modes. You can also use a custom color by entering it’s HEX codes. We do not recommend using the “Custom” option, because it can make the property website look low-quality."
            },
            "agent_details": {
                "add_agent_details": "Добавить данные агента",
                "fill_in": "Введите контактные данные, чтобы посетители знали, кто представляет данные о компании.",
                "agent_profile_photo": "Фото профиля агента",
                "upload_an_image": "Загрузите изображение",
                "full_name": "Полное имя",
                "full_name_placeholder": "Имя фамилия",
                "occupation": "Род занятий",
                "occupation_placeholder": "Агент по недвижимости, брокер, риэлтор ...",
                "contact_email": "Ваш адрес электронной почты",
                "contact_email_placeholder": "johndoe@company.com",
                "company": "Компания",
                "company_placeholder": "Агентство",
                "website": "Веб-страница",
                "website_placeholder": "agency.com",
                "mobile_phone_number": "Номер сотового телефона",
                "mobile_phone_number_placeholder": "888 888 888",
                "share_a": "Расскажи немного о себе",
                "share_a_placeholder": "Например, Николас имеет более 15 лет опыта работы в сфере коммерческой и жилой недвижимости. Он, пожалуй, является самым влиятельным и ответственным брокером розничного сегмента недвижимости в Hell’s Kitchen, превращая его в оживленный ресторан и торговую площадку с космополитической привлекательностью. Будучи одним из партнеров-основателей известной фирмы по недвижимости Wide Arms Realty, Николас помогает контролировать отношения с несколькими ключевыми владельцами и советами кооперативов;",
                "social_media_links": "Ссылки в социальных сетях",
                "copy_paste": "Скопируйте и вставьте ссылки из социальных сетей, чтобы другие могли с ними ознакомиться",
                "make_website_unbranded": "Сделать сайт небрендинговым",
                "co_agent": "Добавить сопредставителя",
                "co_agent_profile_photo": "Фото профиля сопредставителя",
                "co_agents_company": "Компания сопредставителя",
                "co_agents_website": "Веб-страница компании сопредставителя",
                "listing_agent": "Добавить агента по объявлениям",
                "listing_agent_profile_photo": "Фото агента по объявлениям",
                "listing_agent_full_name": "Полное имя агента по объявлениям",
                "listing_agent_occupation": "Род занятий агента по объявлениям",
                "listing_agent_contact_email": "Адрес электронной почты агента по объявлениям",
                "listing_agent_company": "Компания агента по объявлениям",
                "listing_agent_website": "Веб-страница компании агента по объявлениям",
                "listing_agent_mobile_phone_number": "Сотовый телефон агента по объявлениям"
            },
            "crop": {
                "crop_and_resize_photo": "Обрезать фото и изменить размер",
                "adjust_your": "Редактируйте фотографии так, чтобы они лучше смотрелись на выбранном вами шаблоне",
                "crop": "Обрезать"
            },
            "listing_details": {
                "edit_listing_address": "Изменение адреса объявления",
                "we_will": "Данная информация будет использоваться для того, чтобы найти объект на карте и показать его посетителям.",
                "find_your": "Найдите адрес вашей собственности",
                "type_address": "Введите адрес здесь",
                "country": "Страна",
                "street": "Улица",
                "city": "Город",
                "state": "Штат",
                "region_county": "Регион/округ",
                "zip_code": "Индекс",
                "postal_code": "Почтовый код",
                "information_about": "Информация о районе",
                "continue": "Продолжить",
                "information_about_placeholder": "Например, вы находитесь менее чем в двух кварталах от поезда L и недалеко от поездов J и Z. Позвольте себе расслабиться на открытом воздухе в общественном месте? Прогуляйтесь по парку Ирвинг-сквер и найдите время, чтобы расслабиться, всего в нескольких кварталах от вашего дома. Не стесняйтесь обращаться к нам, чтобы ознакомиться с этим прекрасным таунхаусом.",
                "select_country": "Выберите страну"
            },
            "progress_bar": {
                "template": "Шаблон",
                "address": "Адрес",
                "agent": "Агент",
                "photos": "Фото",
                "remaining_info": "Прочая информация",
                "domain": "Домен"
            },
            "remaining_details": {
                "add_remaining_information": "Добавить прочую информацию",
                "finish_adding": "Добавьте прочую информацию на свою новый веб-страницу – вы почти закончили!",
                "selected_subdomain": "Выбранный под-домен",
                "selected_domain": "Выбранный домен",
                "change": "Изменить",
                "top_section": "Верхняя часть",
                "title": "Название недвижимости",
                "title_placeholder": "Уникальное местонахождение",
                "bedrooms": "Спальни",
                "bathrooms": "Ванные комнаты",
                "square_footage": "Площадь в футах (квадратных метрах)",
                "square_meters": "M²",
                "price": "Цена",
                "currency": "Валюта",
                "top_section_cover": "Фото верхнего раздела (или добавьте видео)",
                "company_logo": "Логотип компании",
                "upload_logo": "Загрузить логотип",
                "select_from_uploads": "Выбрать из загрузок",
                "transparent_background_recommended": "(рекомендуется прозрачный фон)",
                "change_photo": "Сменить фотографию",
                "crop_and_resize": "Обрезать и изменить размер",
                "description": "Описание",
                "description_title": "Заголовок описания (необязательно)",
                "description_title_placeholder": "Культовая жизнь",
                "describe_your_property": "Опишите вашу недвижимость здесь",
                "describe_your_property_placeholder": "Особняк на две семьи, отличается от всех остальных в Бруклине. Если вы искали дом, который действительно просторный, светлый, с продуманной планировкой и дизайном, то вы его нашли. 64 Jackson – это совершенно новый дом, построенный по индивидуальному заказу, в котором все продуманно до мельчайших деталей, и выполнено с мастерством. Это не дом, построенный застройщиком для продажи, это искусно созданная резиденция, в которой все аспекты строительства превосходят ожидание. Дом, спроектированный студией Asa Barak Studio, построен из великолепного импортного кирпича Petersen, обработанного водной струей.",
                "description_images": "Описание изображений",
                "select_1st_favorite": "Выберите фотографию №1, которая вам по душе",
                "select_2nd_favorite": "Выберите фотографию №2, которая вам по душе",
                "floor_plans": "Планировка этажей",
                "floor_plan_images": "Изображения плана этажа",
                "upload_floor_plans": "Загрузить планы этажей",
                "amenities": "Удобства",
                "amenities_description": "Добавьте сведения об объекте недвижимости самостоятельно или выберите их из списка",
                "add_custom_amenities": "Добавьте индивидуальные удобства",
                "add": "Добавить",
                "rooms": "Комнаты",
                "floor_covering": "Напольное покрытие",
                "indoor_features": "Внутренние особенности",
                "building_and_exterior": "Здание & Экстерьер",
                "architectural_style": "Архитектурный стиль",
                "exterior": "Экстерьер",
                "roof": "Крыша",
                "view": "Вид",
                "outdoors_and_parking": "Снаружи & Стоянка",
                "parking": "Стоянка",
                "features": "Особенности",
                "outdoor_amenities": "Удобства вне дома",
                "expand": "Развернуть",
                "utilities": "Коммунальные особенности",
                "cooling": "Охлаждение",
                "heating": "Отопление",
                "publish": "Разместить",
                "preview_website": "Предварительный просмотр веб-страницы",
                "breakfast_nook": "Уголок для завтрака",
                "dining_room": "Столовая",
                "family_room": "Гостиная",
                "laundry_room": "Прачечная",
                "library": "Библиотека",
                "master_bath": "Главная ванная ",
                "mud_room": "Прихожая",
                "office": "Офис",
                "pantry": "Кладовая",
                "recreation_room": "Комната отдыха",
                "workshop": "Мастерская",
                "solarium_atrium": "Солярий/атриум",
                "sun_room": "Веранда",
                "walk_in_closet": "Гардеробная комната",
                "carpet_floor": "Ковровое покрытие",
                "concrete_floor": "Бетонный пол",
                "hardwood_floor": "Деревянный пол",
                "laminate_floor": "Ламинат",
                "linoleum_vinyl_floor": "Линолеум/виниловый пол",
                "slate_floor": "Плиточный пол",
                "softwood_floor": "Пол из мягкой древесины",
                "tile_floor": "Кафельный пол",
                "attic": "Чердак",
                "cable_ready": "Кабель готов",
                "ceiling_fans": "Потолочные вентиляторы",
                "double_pane_windows": "Окна с двойным стеклом",
                "fireplace": "Камин",
                "intercom": "Внутренняя связь",
                "jetted_tub": "Гидромассажная ванна",
                "security_system": "Система безопасности",
                "skylights": "Мансардные окна",
                "wired": "Проводка",
                "bungalow": "Бунгало",
                "cape_cod_style": "Стиль Кейп-Код ",
                "modern_style": "Стиль модерн",
                "victorian_style": "Викторианский стиль",
                "colonial_style": "Колониальный стиль",
                "ranch_rambler": "Ранчо/Рамблер",
                "contemporary_style": "Современный стиль",
                "spanish_style": "Испанский стиль",
                "french_style": "Французский стиль",
                "georgian_style": "Грузинский стиль",
                "loft": "Верхний этаж",
                "tudor": "Тюдор",
                "brick_exterior": "Кирпичный фасад",
                "cement_concrete_exterior": "Цементный/бетонный фасад",
                "composition_exterior": "Композитный фасад",
                "metal_exterior": "Металлический фасад",
                "stone_exterior": "Каменный фасад",
                "wood_wood_product_exterior": "Деревянный фасад",
                "vinyl_exterior": "Виниловый фасад",
                "stucco_exterior": "Оштукатуренный фасад",
                "asphalt_roof": "Асфальтовая крыша",
                "built_up_roof": "Сборная крыша",
                "composition_roof": "Композитная крыша",
                "metal_roof": "Металлическая крыша",
                "shake_shingle_roof": "Дранка/черепица",
                "slate_roof": "Шиферная крыша",
                "tile_roof": "Черепичная крыша",
                "city_view": "Вид на город",
                "mountain_view": "Вид на горы",
                "park_view": "Вид на парк",
                "territorial_view": "Вид на территорию",
                "water_view": "Вид на водоем",
                "no_parking": "Нет парковки",
                "off_street_parking": "Парковка во дворе",
                "on_street_parking": "Парковка на улице",
                "garage_detached": "Гараж - отдельно ",
                "garage_attached": "Гараж - пристроен",
                "carport_parking": "Парковка под навесом",
                "gated_entry": "Закрытый вход",
                "basketball_court": "Баскетбольная площадка",
                "near_transportation": "Транспорт рядом",
                "controlled_access": "Контролируемый доступ",
                "sports_court": "Спортивная площадка",
                "childrens_playground": "Детская площадка",
                "tennis_court": "Теннисный корт",
                "elevator": "Лифт",
                "doorman": "Швейцар",
                "balcony_patio": "Балкон/патио",
                "hot_tub_spa": "Гидромассажная ванна/спа",
                "greenhouse": "Теплица",
                "garden": "Сад",
                "fenced_yard": "Огороженный двор",
                "dock": "Док",
                "deck": "Площадка",
                "barbecue_area": "Площадка для барбекю",
                "lawn": "Газон",
                "pond": "Пруд",
                "pool": "Бассейн",
                "porch": "Крыльцо",
                "sauna": "Сауна",
                "central_cooling": "Центральное охлаждение",
                "solar_cooling": "Солнечное охлаждение",
                "evaporative_cooling": "Охлаждение испарением",
                "geothermal_cooling": "Геотермальное охлаждение",
                "refrigeration": "Охлаждение холодильным оборудованием",
                "ac": "Кондиционер",
                "coal_heating": "Угольное отопление",
                "electric_heating": "Электрическое отопление",
                "gas_heating": "Газовое отопление",
                "oil_heating": "Масляное отопление",
                "propane_butane_heating": "Отопление пропаном/бутаном",
                "wood_pellet_heating": "Отопление дровами/гранулами",
                "solar_heating": "Солнечное отопление",
                "change_top_section_image": "Выберите изображение в верхнем разделе",
                "change_top_section_image_description": "Выберите одно изображение, которое будет отображаться вверху вашей страницы – это первое, что увидят посетители, когда зайдут на вашу страницу. Хотите добавить новую фотографию? Перейдите во вкладку «Фото» и загрузите туда.",
                "change_description_image": "Выберите фото описания",
                "change_description_image_description": "Выберите одну из фотографий, которая будет отображаться вместе с описанием страницы.",
                "back_to_editing": "Вернуться",
                "you_are_almost_done": "Вы почти закончили!",
                "you_are_almost_done_text": "Выберите домен и пусть вашу страничку узнают во всем мире",
                "select_domain": "Выбрать домен",
                "interior": "Интерьер",
                "property_title_is_missing": "Название собственности отсутствует",
                "description_text_is_missing": "Текст описания отсутствует",
                "messenger": "Чат в мессенджере",
                "connect_facebook_page": "Разместите свою страницу в Facebook, чтобы общаться с посетителями вашей странички объявлений в режиме реального времени. Обратите внимание, что пока ваше объявление не будет опубликовано, чат не доступен.",
                "select_facebook_page": "Выберите страницу для подключения",
                "connect_with_facebook": "Подключитесь через Facebook",
                "select_a_page": "Выберите страницу",
                "exit_intent_popup": "Показать всплывающее окно с намерением выхода",
                "just_listed": "Только что добавленные",
                "price_reduced": "Цена снижена",
                "pending": "В ожидании",
                "sold": "Продано",
                "active": "Активный",
                "no_status": "Скрыть статус",
                "capture_more_leads": "Привлекайте больше потенциальных клиентов с помощью всплывающего окна, показываемого посетителям сайта, которые хотят покинуть сайт",
                "visitors_have_to_signup": "Чтобы посмотреть это объявление, необходимо зарегистрироваться по электронной почте. Отлично подходит для новой или будущей недвижимости.",
                "view_after_signup": "Просмотр объявления только после регистрации",
                "listing_status": "Статус объявления",
                "display_more_listings": "Display more listings",
                "display_more_listings_description": "Let your website visitors discover other listings you have on Pillar with an additional “More listings” section.",
                "change_colors": "Change colors",
                "change_colors_description": "Customise your property website with different colors",
                "choose_color": "Choose one of the recommended colors below, which are compatible with both light and dark modes. You can also use a custom color by entering its HEX code.",
                "button_color": "Button color",
                "accent_color": "Accent color",
                "custom": "Custom"
            },
            "select_domain": {
                "select_domain": "Выберите платный или бесплатный домен",
                "choose_from": "Выбирайте из лучших и уникальных доменов недвижимости. От $ 15",
                "use_our_subdomain": "А) Используйте наш бесплатный поддомен",
                "always_free": "Всегда бесплатно, меняйте, когда пожелаете",
                "or_buy": "Б) Купить уникальный домен",
                "search": "Поиск",
                "get_the_perfect_domain": "Получите идеальный домен",
                "view_other_domains": "Посмотреть другие домены",
                "show_country_domains": "Показать домены страны",
                "unavailable": "Недоступен",
                "checkout": "Выйти",
                "payment_details": "Детали оплаты",
                "your_payment_was_successful": "Ваш платеж успешно завершен",
                "congratulations": "Поздравляю! Ваше объявление будет доступно на",
                "grab_a_coffee": "Возьмите чашечку кофе и расслабьтесь – мы переносим все на ваш новый домен, и он будет готов примерно через час.",
                "in_the_meantime": "А пока вы можете отредактировать объявление или сразу же опубликовать его.",
                "publish_website": "Опубликовать страницу",
                "back_to_editing": "Вернуться к редактированию",
                "simply_enter_the_name": "Просто введите название своего поддомена и нажмите «Выбрать».",
                "your_domain": "Ваш домен",
                "you_are_owner_of": "Вы владелец",
                "domain": "домена",
                "for_this_listing": "этого списка",
                "the_domain_you_bought_is": "Вы купили домен",
                "please_contact_our_support": "Если вы хотите изменить свой домен, обратитесь в нашу службу поддержки.",
                "view_live_website": "Посмотреть страничку",
                "go_to_dashboard": "Перейти к приборной панели",
                "selected": "Выбрано",
                "select_free_subdomain": "Выбрать бесплатный поддомен",
                "selected_free_subdomain": "Выбрано"
            }
        },
        "dashboard": {
            "your_listings": "Ваши объявления",
            "upgrade": "Обновить",
            "upgrade_to_create_another_listing": "Обновите, чтобы создать другое объявление",
            "upgrade_plan": "План обновления",
            "account_settings": "Настройки учетной записи",
            "contact_support": "Связаться с поддержкой",
            "facebook_pixel": "Facebook Pixel",
            "logout": "Выйти",
            "edit": "Редактировать",
            "draft": "Черновик",
            "published": "Опубликовано",
            "create_new_listing": "Создать новое объявление",
            "unpublish": "Удалить публикацию",
            "unpublish_text": "Вы действительно хотите отметить эту веб-страницу как неопубликованную? Она больше не будет доступна посетителям вашей веб-страницы",
            "unpublish_website": "Удалить опубликованную веб-страницу",
            "delete": "Удалить",
            "delete_text": "Вы уверены, что хотите удалить эту веб-страницу?",
            "delete_website": "Удалить веб-страницу",
            "duplicate": "Дублировать",
            "duplicate_listing": "Дублировать объявление",
            "duplicate_text": "Вы уверены, что хотите дублировать это объявление?",
            "listing_duplicated": "Объявление дублировано",
            "unable_to_duplicate": "Дублирование не получилось. Пожалуйста, обновите, чтобы добавить объявление",
            "no_status": "Нет статуса",
            "just_listed": "Только что добавленные",
            "active": "Активные",
            "price_reduced": "Цена снижена",
            "pending": "В ожидании",
            "sold": "Продано",
            "view_analytics": "Посмотреть аналитику",
            "search_address": "Поиск адреса",
            "filter": "Фильтр",
            "created": "Созданный",
            "visit": "посещать"
        },
        "passwords": {
            "password": "В пароле должно быть не менее чем восемь символов, и он должен соответствовать подтверждению.",
            "reset": "Ваш пароль был сброшен!",
            "sent": "Мы отправили вам ссылку для сброса пароля по электронной почте!",
            "token": "Данный значок сброса пароля недействителен.",
            "user": "Нам не удалось найти пользователя с таким адресом электронной почты."
        },
        "templates": {
            "sections": {
                "additional_files": {
                    "download_file": "Загрузка файла",
                    "link": "Ссылка",
                    "open_link": "Открыть ссылку"
                }
            },
            "1": {
                "amenities": {
                    "1": "Высокие потолки",
                    "2": "Вид на городские огни",
                    "3": "Замечательные школы вблизи",
                    "4": "Центральное отопление",
                    "5": "Большая кухня",
                    "6": "Большая парковка",
                    "7": "Новое здание",
                    "8": "Гардеробная комната",
                    "9": "Открытый план этажа",
                    "10": "Тихо и уединенно",
                    "11": "Центр города",
                    "12": "Сауна",
                    "13": "Большая терраса на крыше",
                    "14": "Задний двор",
                    "15": "Рядом с магазином"
                },
                "country": "Соединенные Штаты",
                "title": "Место, которое не похоже одно на другое",
                "overview_title": "Культовая жизнь",
                "overview_description": "Особняк на две семьи, отличается от всех остальных в Бруклине. Если вы искали дом, который действительно просторный, светлый, с продуманной планировкой и дизайном, то вы его нашли.\n64 Jackson – это совершенно новый дом, построенный по индивидуальному заказу, в котором все продуманно до мельчайших деталей, и выполнено с мастерством. Это не дом, построенный застройщиком для продажи, это искусно созданная резиденция, в которой все аспекты строительства превосходят ожидание. Дом, спроектированный студией Asa Barak Studio, построен из великолепного импортного кирпича Petersen, обработанного водной струей.\nЭтот 25'дом полностью оборудован для того, чтобы с комфортом принять до 150 гостей или для уединенного отдыха в читальном уголке у камина. Планировка гибкая – гостиная площадью более 1085 квадратных футов открытого лофта. Кухня оснащена мобильным островом, бесшовной раковиной из нержавеющей стали и меблирована дубовыми шкафами с однослойной отделкой. Комната позволяет изменять и трансформировать пространство в зависимости от требований к развлечениям. На веранде – открытый газовый камин со стеклянными панелями от пола до потолка и индивидуальной металлической отделкой. Это пространство, которое нужно увидеть, чтобы по-настоящему оценить его достоинства.\n  ",
                "currency_symbol": "$ ",
                "full_name": "Николас Аарон",
                "occupation": "Лицензированный продавец недвижимости",
                "company": "Wide Arms Realty ",
                "contact_email": "nicolas.aaron@widearmsrealty.com",
                "mobile_phone_number": "646.400.3609 ",
                "website": "https://usepillar.com ",
                "about": "Например, Николас имеет более 15 лет опыта работы в сфере коммерческой и жилой недвижимости. Он, пожалуй, является самым влиятельным и ответственным брокером розничного сегмента Hell’s Kitchen, превращая его в оживленный ресторан и торговую площадку с космополитической привлекательностью. Будучи одним из партнеров-основателей известной фирмы по недвижимости Wide Arms Realty, Николас помогает контролировать отношения с несколькими ключевыми владельцами и советами кооперативов.",
                "facebook": "https://usepillar.com ",
                "twitter": "https://usepillar.com ",
                "linkedin": "https://usepillar.com ",
                "instagram": "https://usepillar.com ",
                "city": "NY ",
                "state": "штат",
                "street": "67 Jackson St ",
                "postcode": "почтовый индекс",
                "property_details": "Например, вы находитесь менее чем в двух кварталах от поезда L и недалеко от поездов J и Z. Позвольте себе расслабиться на открытом воздухе в общественном месте? Прогуляйтесь по парку Ирвинг-сквер и найдите время, чтобы расслабиться, всего в нескольких кварталах от вашего дома. Не стесняйтесь обращаться к нам, чтобы ознакомиться с этим прекрасным таунхаусом.",
                "plans": "Планировка этажей"
            },
            "general": {
                "overview": "Обзор",
                "amenities": "Удобства",
                "amenities_you_will_enjoy": "Удобства, которые вам понравится",
                "photos": "Фото",
                "view_all_photos": "[2,9] Посмотреть все {count}|[10,20] Посмотреть все {count}|[21,29] Посмотреть все {count}",
                "floor_plans": "Планировка этажей",
                "map": "Карта",
                "contact": "Связаться",
                "agent": "Агент",
                "inquire": "Спросить",
                "beds": "Кровать|Кровати",
                "baths": "Ванная комната|Ванная комнаты",
                "bedrooms": "Спальня|Спальни",
                "bathrooms": "Ванная комната|Ванная комнаты",
                "Sq. Ft.": "Кв. футов",
                "tour_this_house": "Тур по этому дому",
                "tour_the_house": "Тур по дому",
                "view_all": "Посмотреть все",
                "view_photos": "фото",
                "location": "Место расположения",
                "open_maps": "Открытые карты",
                "presented_by": "Представлено",
                "get_in_touch": "Связаться",
                "first_name": "Имя",
                "last_name": "Фамилия",
                "email_address": "Адрес электронной почты",
                "email": "Адрес электронной почты",
                "phone": "Телефон",
                "phone_number": "Телефонный номер",
                "your_message": "Ваше сообщение",
                "message": "Сообщение",
                "send_message": "Отправить сообщение",
                "send_inquiry": "Отправить запрос",
                "send": "Отправить",
                "powered_by": "Посредством",
                "share_this_property": "Поделиться информацией о данной недвижимости",
                "close": "Закрыть",
                "view_our_gallery": "Просмотреть нашу галерею",
                "location_in_town": "Расположение в городе",
                "any_questions": "Вопросы?",
                "reach_out_to_us": "Свяжитесь с нами",
                "type_here": "Введите здесь ...",
                "view_photo": "Посмотреть фото",
                "address": "Адрес",
                "price_from": "Цена от",
                "area": "Площадь",
                "explore": "Просмотреть",
                "thank_you_for_your_interest": "Благодарим вас за интерес проявленный к",
                "we_will_contact_you": "Вскоре один из наших сотрудников свяжется с вами, чтобы договориться о конфиденциальной беседе.",
                "scroll": "Прокрутить",
                "gallery": "Галерея",
                "location_overflow": "Место расположения",
                "presented_by_overflow": "Представлено",
                "video_tour": "Видео",
                "video": "Видео",
                "virtual_tour": "Видео тур",
                "more": "Больше",
                "listed_by": "Представлено",
                "or": "или",
                "showing": "Показ",
                "book_a_showing": "Забронировать показ",
                "just_listed": "ТОЛЬКО ЧТО ДОБАВЛЕННЫЕ",
                "price_reduced": "ЦЕНА СНИЖЕНА",
                "pending": "В ОЖИДАНИИ",
                "sold": "ПРОДАНО",
                "active": "АКТИВНЫЙ",
                "more_information": "Дополнительная информация",
                "take_a_tour": "Принять участие в туре",
                "more_listings": "More listings"
            }
        },
        "free_trial": {
            "your_free_trial_ends_in": "Ваша бесплатная пробная версия заканчивается через",
            "days": "{count} день|{count} дней",
            "upgrade": "Обновить"
        },
        "subdomain_selected": {
            "subdomain_selected": "Выбран поддомен",
            "congratulations": "Поздравляю! Ваше объявление будет доступно на",
            "congratulations_description": "Вы можете редактировать объявление или сразу же опубликовать его.",
            "publish_website": "Опубликовать веб-страницу",
            "back_to_editing": "Вернуться к редактированию"
        },
        "common": {
            "back": "Назад",
            "continue": "Продолжить",
            "next": "Следующий",
            "max_file_size": "Максимальный размер файла: 20 МБ",
            "preview": "Предварительный просмотр",
            "file_size_too_big": "Размер файла превышает максимальный – максимальный размер файла 20 МБ.",
            "close": "Закрыть",
            "cancel": "Отменить",
            "select": "Выбрать",
            "crop_and_resize": "Обрезать и изменить размер",
            "change_photo": "Сменить фотографию",
            "remove_photo": "Удалить фото",
            "are_you_sure": "Вы уверены, что хотите удалить это фото?",
            "remove": "Удалить",
            "terms_of_service": "Условия обслуживания",
            "terms_of_service_nominative": "Условия обслуживания",
            "privacy_policy": "Политика конфиденциальности",
            "and": "и",
            "all_rights_reserved": "© Pillar Technologies LTD 2020. Все права защищены.",
            "currency_sign": "$",
            "dashboard": "Панель приборов",
            "desktop": "Рабочий стол",
            "tablet": "Планшет",
            "mobile": "Сотовый",
            "view_demo": "Посмотреть демо",
            "select_template": "Запустить веб-сайт",
            "add_video": "Добавить видео",
            "replace_video": "Заменить видео",
            "select_photo": "Выбрать фото",
            "save": "Сохранить",
            "blog": "Блог",
            "limit_reached_upgrade_plan": "Достигнут лимит активного листинга — обновите свой план"
        },
        "card_details": {
            "card_number": "Код подтверждения карты (CVC) обязателен",
            "name_on_card": "Имя на карте",
            "name_on_card_placeholder": "имя на заполнителе карты",
            "expiration": "истечение срока",
            "order_summary": "итог заказа",
            "domain_for_listing_site": "домен для объявлений веб-страницы",
            "one_time_payment": "одноразовый платеж",
            "no_hidden_fees": "Без скрытых комиссионных платежей",
            "valid_for_one_year": "Действителен в течение одного года",
            "pay": "Платить",
            "card_number_required": "Номер карты обязателен",
            "month_required": "Месяц обязателен",
            "cvc_required": "Код подтверждения карты (CVC) обязателен",
            "name_is_required": "Имя обязательно"
        },
        "account": {
            "account_settings": "Настройки учетной записи",
            "profile": "Профиль",
            "password": "Пароль",
            "billing": "Платежная информация",
            "first_name": "Имя",
            "first_name_placeholder": "Имя-заполнитель",
            "last_name": "Фамилия",
            "last_name_placeholder": "Фамилия-заполнитель",
            "work_email_address": "Адрес рабочей электронной почты",
            "work_email_address_placeholder": "Адрес-заполнитель рабочей электронной почты",
            "old_password": "Старый пароль",
            "new_password": "Новый пароль",
            "password_placeholder": "Пароль-заполнитель",
            "confirm_new_password": "Подтвердите новый пароль",
            "change_password": "Изменить пароль",
            "update_settings": "Обновить настройки",
            "active_listings": "Активные объявления",
            "your_plan": "Ваш план",
            "upgrade": "Обновить",
            "cancel_plan": "Отменить план",
            "change_card": "Сменить карту",
            "payment_method": "Способ оплаты",
            "update_card": "Обновление карты",
            "cancelled": "Отменено",
            "active_until": "активен до",
            "renew": "Возобновить",
            "we_will_send_you_text_notifications": "Мы отправим вам текстовое уведомление, когда на одной из веб-страниц с вашими объектами недвижимости появится новый клиент.",
            "phone_number": "Номер телефона для SMS-уведомлений"
        },
        "analytics": {
            "yesterday": "Yesterday",
            "last_week": "Last week",
            "last_month": "Last month",
            "last_7_days": "Last 7 days",
            "last_30_days": "Last 30 days",
            "all_time": "All time"
        },
        "plan_ended": {
            "please_reactivate_your_plan": "Пожалуйста, активируйте свой план повторно",
            "free_trial_has_ended": "Бесплатная пробная версия закончилась",
            "your": "Ваш/-а",
            "subscription_has_ended": "подписка закончилась",
            "days_free_trial_has_ended": "дневная бесплатная пробная версия закончилась",
            "description": "Надеемся, вам понравилось пользоваться Pillar. Пожалуйста, обновите программу, чтобы продолжить пользоваться нашими услугами.",
            "description2": "Что-то не так? Мы будем рады вас слышать, если у вас возникнут какие-либо вопросы, пожелания или отзывы!",
            "see_plans": "Посмотреть планы",
            "contact_support": "Связаться со службой поддержки"
        },
        "early_preview": {
            "finish_setting_up_title": "Завершите настройку вашего сайта за считанные минуты",
            "finish_setting_up_description": "Отредактируйте остальные детали и выберите домен для своего объявления",
            "continue_editing": "Продолжить редактирование"
        },
        "getting_started": {
            "template": "Шаблон",
            "customization": "Настройка",
            "preview_and_next_steps": "Предварительный просмотр и следующие шаги",
            "preview": "Предварительный просмотр",
            "customize_your_website": "Настройте свою веб-страницу",
            "customize_your_website_description": "Добавьте адрес вашей недвижимости и фотографии. Не волнуйтесь – вы сможете добавить дополнительную информацию позже.",
            "add_property_address": "Добавьте адрес недвижимости",
            "add_property_photos": "Добавьте фотографии недвижимости",
            "i_dont_have_any_photos_with_me": "У меня нет с собой фото",
            "upload_up_to_20_photos": "Загрузите до 20 фото",
            "view_your_website": "Посмотреть свою веб-страницу",
            "or_skip_this_step": "Или пропустите этот шаг",
            "sign_up_to_view_your_website": "Создайте свою первую веб-страницу недвижимости",
            "first_name": "Имя",
            "first_name_placeholder": "Имя",
            "last_name": "Фамилия",
            "last_name_placeholder": "Фамилия",
            "email_address": "Адрес электронной почты",
            "email_address_placeholder": "johndoe@realestate.com",
            "phone_number": "Телефонный номер",
            "phone_number_placeholder": "888 888 8888",
            "create_password": "Введите пароль",
            "create_password_placeholder": "Мин. 8 символов",
            "finish_setting_up_your_account": "Завершите настройку вашей учетной записи",
            "and": "и",
            "by_signing_up_you_agree_to_pillars": "Регистрируясь, вы соглашаетесь с Pillar",
            "not_subscribe_text": "Я не хочу получать обновления о продуктах и новости о продуктах и услугах Pillar.",
            "continue": "Продолжить",
            "sign_up": "Зарегистрироваться",
            "uploading": "Загрузка ...",
            "compressing_photo": "Сжатие фото",
            "unable_to_upload": "Не удалось загрузить файл, попробуйте еще раз.",
            "14_day_free_trial": "7-дневная бесплатная пробная версия",
            "no_card_required": "Карта не требуется",
            "cancel_anytime": "Отмените в любое время"
        },
        "validation": {
            "accepted": "The {attribute} must be accepted.",
            "active_url": "The {attribute} is not a valid URL.",
            "after": "The {attribute} must be a date after {date}.",
            "after_or_equal": "The {attribute} must be a date after or equal to {date}.",
            "alpha": "The {attribute} may only contain letters.",
            "alpha_dash": "The {attribute} may only contain letters, numbers, dashes and underscores.",
            "alpha_num": "The {attribute} may only contain letters and numbers.",
            "array": "The {attribute} must be an array.",
            "before": "The {attribute} must be a date before {date}.",
            "before_or_equal": "The {attribute} must be a date before or equal to {date}.",
            "between": {
                "numeric": "The {attribute} must be between {min} and {max}.",
                "file": "The {attribute} must be between {min} and {max} kilobytes.",
                "string": "The {attribute} must be between {min} and {max} characters.",
                "array": "The {attribute} must have between {min} and {max} items."
            },
            "boolean": "The {attribute} field must be true or false.",
            "confirmed": "The {attribute} confirmation does not match.",
            "date": "The {attribute} is not a valid date.",
            "date_equals": "The {attribute} must be a date equal to {date}.",
            "date_format": "The {attribute} does not match the format {format}.",
            "different": "The {attribute} and {other} must be different.",
            "digits": "The {attribute} must be {digits} digits.",
            "digits_between": "The {attribute} must be between {min} and {max} digits.",
            "dimensions": "The {attribute} has invalid image dimensions.",
            "distinct": "The {attribute} field has a duplicate value.",
            "email": "The {attribute} must be a valid email address.",
            "ends_with": "The {attribute} must end with one of the following: {values}",
            "exists": "The selected {attribute} is invalid.",
            "file": "The {attribute} must be a file.",
            "filled": "The {attribute} field must have a value.",
            "gt": {
                "numeric": "The {attribute} must be greater than {value}.",
                "file": "The {attribute} must be greater than {value} kilobytes.",
                "string": "The {attribute} must be greater than {value} characters.",
                "array": "The {attribute} must have more than {value} items."
            },
            "gte": {
                "numeric": "The {attribute} must be greater than or equal {value}.",
                "file": "The {attribute} must be greater than or equal {value} kilobytes.",
                "string": "The {attribute} must be greater than or equal {value} characters.",
                "array": "The {attribute} must have {value} items or more."
            },
            "image": "The {attribute} must be an image.",
            "in": "The selected {attribute} is invalid.",
            "in_array": "The {attribute} field does not exist in {other}.",
            "integer": "The {attribute} must be an integer.",
            "ip": "The {attribute} must be a valid IP address.",
            "ipv4": "The {attribute} must be a valid IPv4 address.",
            "ipv6": "The {attribute} must be a valid IPv6 address.",
            "json": "The {attribute} must be a valid JSON string.",
            "lt": {
                "numeric": "The {attribute} must be less than {value}.",
                "file": "The {attribute} must be less than {value} kilobytes.",
                "string": "The {attribute} must be less than {value} characters.",
                "array": "The {attribute} must have less than {value} items."
            },
            "lte": {
                "numeric": "The {attribute} must be less than or equal {value}.",
                "file": "The {attribute} must be less than or equal {value} kilobytes.",
                "string": "The {attribute} must be less than or equal {value} characters.",
                "array": "The {attribute} must not have more than {value} items."
            },
            "max": {
                "numeric": "The {attribute} may not be greater than {max}.",
                "file": "The {attribute} may not be greater than {max} kilobytes.",
                "string": "The {attribute} may not be greater than {max} characters.",
                "array": "The {attribute} may not have more than {max} items."
            },
            "mimes": "The {attribute} must be a file of type: {values}.",
            "mimetypes": "The {attribute} must be a file of type: {values}.",
            "min": {
                "numeric": "The {attribute} must be at least {min}.",
                "file": "The {attribute} must be at least {min} kilobytes.",
                "string": "The {attribute} must be at least {min} characters.",
                "array": "The {attribute} must have at least {min} items."
            },
            "not_in": "The selected {attribute} is invalid.",
            "not_regex": "The {attribute} format is invalid.",
            "numeric": "The {attribute} must be a number.",
            "present": "The {attribute} field must be present.",
            "regex": "The {attribute} format is invalid.",
            "required": "The {attribute} field is required.",
            "required_if": "The {attribute} field is required when {other} is {value}.",
            "required_unless": "The {attribute} field is required unless {other} is in {values}.",
            "required_with": "The {attribute} field is required when {values} is present.",
            "required_with_all": "The {attribute} field is required when {values} are present.",
            "required_without": "The {attribute} field is required when {values} is not present.",
            "required_without_all": "The {attribute} field is required when none of {values} are present.",
            "same": "The {attribute} and {other} must match.",
            "size": {
                "numeric": "The {attribute} must be {size}.",
                "file": "The {attribute} must be {size} kilobytes.",
                "string": "The {attribute} must be {size} characters.",
                "array": "The {attribute} must contain {size} items."
            },
            "starts_with": "The {attribute} must start with one of the following: {values}",
            "string": "The {attribute} must be a string.",
            "timezone": "The {attribute} must be a valid zone.",
            "unique": "The {attribute} has already been taken.",
            "uploaded": "The {attribute} failed to upload.",
            "url": "The {attribute} format is invalid.",
            "uuid": "The {attribute} must be a valid UUID.",
            "custom": {
                "attribute-name": {
                    "rule-name": "custom-message"
                }
            },
            "attributes": []
        },
        "components": {
            "schedule_showing": {
                "monday": "Понедельник",
                "tuesday": "Вторник",
                "wednesday": "Среда",
                "thursday": "Четверг",
                "friday": "Пятница",
                "saturday": "Суббота",
                "sunday": "Воскресенье",
                "title": "Доступность для показов"
            },
            "video_tour": {
                "upload_video": "Загрузите видео об объекте недвижимости прямо со своего компьютера, YouTube или загрузите виртуальный тур из таких сервисов, как Matterport.",
                "embed_video": "Вставить видео с YouTube или Vimeo",
                "video_tour": "Видео и виртуальный тур",
                "hd_quality": "HD-качество"
            },
            "embed_virtual_tour": {
                "embed_virtual_tour": "Встроенный виртуальный тур",
                "add_video_link": "URL виртуального тура",
                "video_embedded": "Встроенное видео",
                "failed_to_embed_video": "Не удалось встроить видео. Пожалуйста, проверьте URL",
                "embed_video": "Встроенный виртуальный тур"
            },
            "templates": {
                "lock_listing": {
                    "title": "Продолжить тур по дому",
                    "full_name": "Полное имя",
                    "email_address": "Ваш адрес электронной почты",
                    "phone_number": "Телефонный номер",
                    "tour_this_home": "Тур по этому дому"
                },
                "exit_intent": {
                    "title": "Перед тем, как выйти...",
                    "description": "Хотите первым получать эксклюзивные предложения в вашем районе? Зарегистрируйтесь и сэкономьте!",
                    "full_name": "Полное имя",
                    "email_address": "Ваш адрес электронной почты",
                    "phone_number": "Телефонный номер",
                    "get_offers": "Получать предложения",
                    "no_thanks": "Нет, спасибо",
                    "request_received": "Запрос получен",
                    "we_will_send": "Мы вскоре вышлем лучшие предложения в вашем районе",
                    "close": "Закрыть"
                },
                "book_a_showing": {
                    "book_a_showing": "Заказать показ",
                    "appointment_type": "Тип записи",
                    "in_person": "Лично",
                    "virtual_showing": "Виртуальный показ",
                    "appointment_date": "Дата записи",
                    "preferred_time": "Удобное для вас время",
                    "morning": "Утро",
                    "afternoon": "После полудня",
                    "evening": "Вечер",
                    "full_name": "Полное имя",
                    "john_doe": "Имя фамилия",
                    "email_address": "Ваш адрес электронной почты",
                    "johndoe_realestate_com": "Johndoe@realestate.com",
                    "phone_number": "Телефонный номер",
                    "phone_number_placeholder": "888 888 8888",
                    "additional_information": "Дополнительная информация",
                    "i_would_like_to_shedule_a_showing": "Я хочу забронировать показ",
                    "confirm_booking": "Подтвердите бронирование",
                    "tour_confirmed_for": "тур подтвержден для",
                    "thanks_for_booking": "Спасибо, что предоставили мне возможность забронировать показ. Я уточню подробности в ближайшее время."
                }
            },
            "embed_video": {
                "add_video_link": "Добавить ссылку на видео",
                "embed_video": "Встроить видео с Youtube или Vimeo",
                "video_embedded": "Встроенное видео",
                "failed_to_embed_video": "Не удалось встроить видео",
                "edit_embed_video": "Редактировать обложку видео YouTube или Vimeo",
                "edit_video_link": "Редактировать ссылку на видео",
                "as_top_section_cover": "Добавить это видео в качестве обложки верхнего раздела",
                "hd_quality": "HD-качество"
            },
            "additional_documents": {
                "additional_documents": "Дополнительные документы",
                "upload_a_file": "Загрузить файл",
                "or": "или",
                "insert_a_link": "Вставить ссылку",
                "added_documents": "Прикрепленные документы",
                "edit_link": "Редактировать ссылку",
                "remove": "Удалить",
                "cancel": "Отменить",
                "link_url": "Ссылка URL",
                "link_text": "Текст ссылки",
                "insert_link": "Вставить",
                "edit": "Редактировать",
                "link_text_placeholder": "Название ссылки",
                "link_url_placeholder": "https://drive.google.com/link",
                "update_a_link": "Обновить ссылку",
                "update": "Обновить",
                "delete_file_title": "Удалить файл",
                "delete_link_title": "Удалить ссылку",
                "delete_file_description": "Вы уверены, что хотите удалить этот файл?",
                "delete_link_description": "Вы уверены, что хотите удалить эту ссылку?",
                "change_file_title": "Изменить название файла",
                "file_title": "Название файла"
            }
        },
        "landing_page": {
            "main": {
                "product": "Продукт",
                "pricing": "Цена",
                "designs": "Дизайн",
                "contact_us": "Связаться с нами",
                "login": "Вход",
                "hero_title": "Создайте потрясающую веб-страницу по продаже недвижимости менее чем за 7 минут",
                "hero_description": "Получайте больше объявлений и продавайте быстрее, представляя недвижимость на премиальных веб-страницах, предназначенных для привлечения потенциальных клиентов. Разработчики не нужны.",
                "get_started_for_free": "Создать бесплатно",
                "agents_helped": "Агенты оказали помощь раз/-а",
                "websites_created": "Веб-страниц/-ы создано",
                "plans_and_visuals_made": "Плана/-ов и визуальный/-ых эффект/-ов",
                "stand_out_from_the_croud": "Продавайте быстрее и больше недвижимости",
                "make_your_listings_stnd_out": "Настройте свои объявления, чтобы выделить лучшее в каждом объекте, продемонстрируйте свой опыт и привлекайте потенциальных клиентов посредством элегантных и адаптивных веб-страниц.",
                "faster": "Быстро",
                "faster_description": "Создание веб-страницы вашего объявления займет всего 7 минут.",
                "cheaper": "По хорошей цене",
                "cheaper_description": "Всего 14 долларов в месяц – расширение вашего бизнеса уникальным способом не должно вам обойтись дороже.",
                "beautiful": "Стильно",
                "beautiful_description": "Постоянно обновляемый высококачественный адаптивный дизайн, созданный для привлечения внимания и потенциальных клиентов.",
                "as_easy": "Так же просто, как заполнить бланк",
                "choose_a_template": "Выберите шаблон",
                "choose_a_template_description": "Просто выберите один из наших шаблонов, созданных специально для объявлений о недвижимости.",
                "add_listing_information": "Добавьте информацию об объявлении",
                "add_listing_information_description": "Вставьте информацию в выбранный шаблон, такую как текст и мультимедиа",
                "pick_a_domain": "Выберите домен",
                "pick_a_domain_description": "После того, как вы добавили всю информацию, просто нажмите «Опубликовать» или выберите собственный домен для своей веб-страницы. Ваше объявление теперь доступно!",
                "join_hundreds": "Присоединяйтесь к сотням агентов, которые более эффективно продвигают свои объявления",
                "pillar_helps": "Pillar помогает агентам получать больше потенциальных клиентов – по одному объекту за раз",
                "request_demo": "Запросить демо",
                "what_our_customers_are_saying": "Что говорят наши клиенты",
                "supercharge_your_listing": "Готовы поднять уровень своих объявлений?",
                "supercharge_your_listing_description": "Тратьте больше времени на построение своего бизнеса и меньше проводите за рабочим столом.",
                "spend_more_time_building": "Тратьте больше времени на построение",
                "your_business": "своего бизнеса и меньше времени за рабочим столом.",
                "get_started_now": "Начать сейчас",
                "full_name": "Полное имя",
                "email_address": "Адрес электронной почты",
                "company": "Компания (необязательно)",
                "your_message": "Ваше сообщение",
                "send_message": "Отправить сообщение",
                "arrange_for_consultation": "Запросить демо",
                "first_name": "Имя",
                "last_name": "Фамилия",
                "job_title": "Должность",
                "company_name": "Название компании",
                "phone_number": "Телефонный номер",
                "your_message_optional": "Ваше сообщение (необязательно)",
                "thoughtfully_crafted_designs": "Продуманный дизайн",
                "our_designs": "Наши дизайны специально созданы для того, чтобы ваша недвижимость могла выделяться, помогая вам легко привлекать потенциальных клиентов.",
                "view_designs": "Посмотреть дизайны",
                "view": "Посмотреть",
                "get_started": "Попробуйте бесплатно",
                "book_a_demo": "Заказать демо",
                "create_now": "Создать сейчас",
                "free_trial_no_cc_required": "7-дневная бесплатная пробная версия. Карточка не требуется.",
                "see_how_it_works": "Посмотреть, как это работает",
                "watch_our_demo": "Посмотрите нашу двухминутную демонстрацию",
                "dont_believe_how_easy_it_is": "Не верите насколько это просто? Посмотрите наше демонстрационное пошаговое руководство, показывающее, как создать единую веб-страницу недвижимости за считанные минуты",
                "as_seen_on": "Также как на",
                "trusted_by": "Наши партнеры",
                "review_1": "«Это так просто. Я уже успел получить право представительства нескольких новых объектов недвижимости, потому что быстро создал для них сайты. Дизайн отличный и выглядит профессионально.»",
                "review_2": "«Самый красивый, универсальный и самый быстрый способ создать сайт о недвижимости, который я когда-либо видел. Работать с ним очень просто, настоятельно рекомендуется всем, не упуская ни одной стильной детали и экономя сотни (если не тысячи)»",
                "review_3": "«Pillar задает тон и создает тенденцию эффективного создания стильных веб-страниц, которые могли бы быть созданы только профессиональным агентством веб-дизайна. Качество шаблонов – именно благодаря этому Pillar превосходит своих конкурентов.»",
                "review_4": "«Я быстро зарегистрировался на платформе, чтобы связаться с владельцем и получить контакты объявления! Только что договорились, и я покупаю дом. Ура, ребята!»",
                "review_5": "«Три дня назад я поделилась своими новыми объявлениями, используя сеть и базу данных клиентов. На сегодняшний день у меня уже 5 потенциальных покупателей, запрашивающих информацию об объекте, и с 3 из них я уже договорился о просмотре!»"
            },
            "components": {
                "exit_intent_popup": {
                    "enter_your_email": "Введите адрес электронной почты и получите скидку в 10% на любой план!",
                    "email_address": "Эл. адрес",
                    "yes_i_want_discount": "Да! Получить 10% скидку",
                    "no_thanks": "Нет, спасибо",
                    "discount_applied": "Мы применили скидку на вашу электронную почту - теперь завершите регистрацию, чтобы использовать ее!",
                    "finish_signing_up": "Завершить регистрацию"
                }
            },
            "get_started": {
                "select_a_template": "Выберите шаблон",
                "select_a_template_description": "Выберите один из шаблонов из нашего списка, каждый из которых был создан для определенной цели. Не волнуйтесь - вы можете изменить шаблон позже, если захотите."
            },
            "pricing": {
                "hero_title": "Доступная цена для всех",
                "hero_description_1": "Кредитная карта не требуется.",
                "hero_description_2": "Все планы включают поддержку клиентов 24/7. Измените или отмените свой план в любое время.",
                "additional_services": "Дополнительные услуги",
                "3d_plans": "3D планы",
                "3d_plans_description": "Закажите индивидуальный 3D-план для вашей недвижимости в течение 3 рабочих дней с учетом плана этажа и требований. Свяжитесь с нами для получения более подробной информации.",
                "plan": "план",
                "visual": "визуально",
                "visualizations": "Визуализации",
                "visualizations_description": "Получите визуализацию высочайшего качества за 3 рабочих дня. Свяжитесь с нами для получения более подробной информации.",
                "faq_question_1": "Есть ли бесплатная пробная версия?",
                "faq_answer_1": "Да, мы предлагаем 14-дневную бесплатную пробную версию для 5 веб-страниц со списком объявлений. Бесплатная пробная версия полностью функциональна.",
                "faq_question_2": "Сколько стоят веб-страницы с одной собственностью?",
                "faq_answer_2": "Наша подписка начинается с 14 долларов в месяц. Чем больше у вас веб-страниц, тем дешевле становится каждая из них. Подписки ежемесячные без заключения договора. Вы можете повысить, понизить или отменить свой план в любое время. Посетите нашу страницу «Планы и цены» для получения более подробной информации.",
                "faq_question_3": "Сколько стоят персонализированные домены?",
                "faq_answer_3": "Мы предлагаем персонализированные домены за 15 долларов – вы можете приобрести домен прямо у Pillar.",
                "faq_question_4": "Что, если я достигну своего лимита объявлений?",
                "faq_answer_4": "Если вы достигнете своего лимита объявлений, вы можете перейти на более обширный план с более высоким лимитом.",
                "faq_question_5": "Почему стоит выбрать годовой план?",
                "faq_answer_5": "Мы предлагаем 15% скидку от ежемесячной цены при предоплате за 12 месяцев. Отличный вариант, если вам нравятся скидки!",
                "faq_question_6": "Могу ли я загружать и отображать на своих веб-страницах файлы, например планы этажей, документы, видео?",
                "faq_answer_6": "Да. Мы об этом позаботились! Вы можете добавлять документы на каждую веб-страницу недвижимости.",
                "faq_question_7": "Могу ли я отображать виртуальные 3D-туры на веб-страницах недвижимости?",
                "faq_answer_7": "Да, вы удивитесь, насколько это просто.",
                "faq_question_8": "Когда недвижимость продается, могу ли я удалить ее, чтобы освободить место для другой веб-страницы?",
                "faq_answer_8": "Да! вы можете удалить веб-страницу недвижимости, как только объект будет продан, и у вас появится место для другого. У вас может быть столько веб-страниц, сколько позволяет ваш план подписки.",
                "whats_included": "Что включено",
                "coming_soon": "Скоро",
                "faq": "Часто задаваемые вопросы",
                "mobile_first": "Сначала мобильные",
                "free_subdomain": "Бесплатный поддомен",
                "free_hosting": "Бесплатный хостинг",
                "messenger_live_chat": "Чат в реальном времени",
                "buy_a_unique_domain": "Покупка уникального домена",
                "upload_docs_and_links": "Загрузка документов и ссылок",
                "integrate_virtual_tour": "Интегрированный виртуальный тур",
                "upload_videos_and_floor_plans": "Загрузка видео и планов этажей",
                "free_ssl_certificates": "Бесплатные SSL-сертификаты",
                "google_maps": "Google maps",
                "facebook_pixel": "Facebook Pixel",
                "share_to_social_media": "Возможность поделиться в социальных сетях",
                "schedule_a_showing": "Бронирование показа",
                "seo_optimized": "Оптимизация SEO",
                "mls_unbranded_version": "Небрендированная версия",
                "leave_intent_capture": "Всплывающее окно при выходе",
                "set_as_just_listed": "Возможность отметить как «только что перечисленные», «цена снижена», «в ожидании», «продано»",
                "unlock_listing_capture": "Просмотр объявления только после регистрации",
                "add_open_house_times": "Добавьте часы открытых дверей",
                "coming_soon_lead_capture": "«Вскоре» - всплывающее окно предложения",
                "listing_website_analytics": "Аналитика объявлений веб-сайта"
            },
            "designs": {
                "hero_title": "Дизайн, который поможет вам отличаться от других",
                "hero_description": "Специально разработан для демонстрации особенностей, привлечения потенциальных клиентов и более быстрых продаж. Выберите шаблон и создайте свою бесплатную веб-страницу за считанные минуты"
            }
        },
        "pixel": {
            "title": "Добавить Facebook Pixel",
            "description": "Введите свой код Facebook Pixel для сбора данных, которые помогут вам отслеживать конверсии из рекламы Facebook для всех ваших списков Pillar.",
            "add_easy": "Добавить Pixel ID действительно очень просто:",
            "first_step": "скопируйте свой Facebook Pixel ID, который хотите использовать для наших сайтов",
            "first_step_more": "Если у вас его нет, следуйте инструкциям Facebook, чтобы",
            "first_step_link_title": "создать свой первый Pixel",
            "second_step": "вставьте свой Pixel ID ниже и нажмите «Сохранить ID». Готово!",
            "third_step": "Мы уже настроили все события конверсии в наших шаблонах, поэтому вы сразу увидите события, как только добавите базовый код.",
            "add_your_pixel_code": "Добавьте свой базовый код Pixel",
            "add_your_pixel_code_placeholder": "<!-- Facebook Pixel Code -->\n    <script>\n      !function(f,b,e,v,n,t,s)\n      {if(f.fbq)return;n=f.fbq=function(){n.callMethod?\n      n.callMethod.apply(n,arguments){n}.queue.push(arguments)};\n      if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';\n      n.queue=[];t=b.createElement(e);t.async=!0;\n      t.src=v;s=b.getElementsByTagName(e)[0];\n      s.parentNode.insertBefore(t,s)}(window, document,'script',\n      'https://connect.facebook.net/en_US/fbevents.js');\n      fbq('init', '288089709022004');\n      fbq('track', 'PageView');\n    </script>\n    <noscript><img height=\"1\" width=\"1\" style=\"display{none}\"\n      src=\"https://www.facebook.com/tr?id=288089709022004&ev=PageView&noscript=1\"/></noscript>\n    <!-- End Facebook Pixel Code -->",
            "save_code": "Сохранить код"
        },
        "pricing": {
            "choose_a_plan": "Выберите план",
            "choose_a_plan_description": "Все планы включают поддержку клиентов 24/7. Измените или отмените свой план в любое время.",
            "monthly": "Ежемесячно",
            "yearly": "Ежегодно",
            "save_15_percent": "Сэкономьте 15%",
            "starter": "Стартер",
            "advanced": "Продвинутый",
            "professional": "Профессиональный ",
            "professional_30": "Профессиональный 30",
            "professional_60": "Профессиональный 60",
            "professional_120": "Профессиональный 120",
            "enterprise": "Корпоративный",
            "mo": "месяц",
            "starter_description": "Создайте 1 веб-страницу с описанием вашего особого объекта недвижимости",
            "advanced_description": "Создавайте до 5 веб-страниц со списком объявлений одновременно",
            "professional_description": "Создавайте до 15 веб-страниц со списком объявлений одновременно",
            "professional_30_description": "Обновите свой профессиональный план, чтобы создать до 30 веб-страниц объявлений",
            "professional_60_description": "Обновите свой профессиональный план, чтобы создать до 60 веб-страниц объявлений",
            "professional_120_description": "Обновите свой профессиональный план, чтобы создать до 120 веб-страниц объявлений",
            "enterprise_description": "Расширенные функции для команд, индивидуальный брендинг и многое другое",
            "enterprise_feature_1": "Неограниченное количество объявлений",
            "enterprise_feature_2": "Расширенная безопасность",
            "enterprise_feature_3": "Разрешения и рабочие процессы",
            "select": "Выбрать",
            "current_plan": "Текущий план",
            "plan": "план",
            "billed": "Выставлен счет",
            "total_billed": "Всего выставлено",
            "upgrade_my_plan": "Обновить мой план",
            "contact_us": "Связаться с нами",
            "order_summary": "Итог заказа",
            "renew_successful": "Продлено успешно",
            "back_to_dashboard": "Вернуться к панели управления",
            "add_another_listing": "Добавить объявление",
            "lets_finish_upgrading": "Закончим обновление",
            "plan_is_right_for_you": "этот план вам подходит ",
            "upgrade_successful": "Обновление успешно выполнено",
            "starter_monthly_price": "12",
            "starter_yearly_price": "10",
            "advanced_monthly_price": "42",
            "advanced_yearly_price": "36",
            "professional_monthly_price": "84",
            "professional_yearly_price": "72",
            "3d_plan_price": "99",
            "visual_price": "399",
            "other_plans": "Другие планы",
            "advanced_monthly_per_site": "8.4",
            "advanced_yearly_per_site": "7.2",
            "professional_monthly_per_site": "5.6",
            "professional_yearly_per_site": "4.8",
            "professional_30_monthly_per_site": "3.4",
            "professional_30_yearly_per_site": "2.9",
            "professional_60_monthly_per_site": "2.9",
            "professional_60_yearly_per_site": "2.5",
            "professional_120_monthly_per_site": "2.5",
            "professional_120_yearly_per_site": "2.1",
            "per_site_month": "за веб-страницу в месяц",
            "per_additional_site_month": "за дополнительную веб-страницу в месяц"
        },
        "listing_published": {
            "listing_published": "Объявление опубликовано",
            "congratulations": "Поздравляем",
            "your_listing": "Ваша веб-страница с объявлениями была опубликована. А теперь чтобы получить новых потенциальных клиентов, вам необходимо поделиться ссылкой!",
            "view_live_website": "Посмотреть веб-страницу",
            "dashboard": "Панель приборов",
            "copy_link": "Копировать ссылку"
        }
    }
}

})));